import { React, useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import upgrade from "../../../Assets/Icons/up-range.svg";
import downgrade from "../../../Assets/Icons/down-range.svg";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  ResultWrap,
  TableLayoutData,
  PipeDesign,
  ContentMiddle,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Tabs,
  Row,
  Col,
  Table,
  Tooltip,
  Radio,
  Input,
  Form,
  Skeleton,
} from "antd";
import { Styled, RadioButtonStyle } from "../../pageStyled";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  approveRejectJobCard,
  cancelJobCard,
  createNewSolution,
  getAlgorithmCompletionStatus,
  getFailedGroups,
  getIntermediateList,
  getJobCardCylinders,
  getJobCardsById,
  getJobCardsDetails,
  readyJobCardSinglestageNewSolution,
} from "../../../Services/deckleMatchServices";
import { getOrdersList, getPosData } from "../../../Services/orderServices";
import moment from "moment";
import { TableList, JobCardColorStatus } from "../../pageStyled";
import { HaberForm } from "../../styledElements";
import JobCardCylinderContainer from "../../../Components/JobCardCylinders/JobCardCylinderContainer";
import warning from "../../../Assets/Icons/warning.png";
import warningjob from "../../../Assets/Icons/warningjob.svg";
import { ModalPopup } from "../../../Components/Modal/modal";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import JobCardRejectDrawer from "./JobCardRejectDrawer/JobCardRejectDrawer";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { getStocksDetailsByIds } from "../../../Services/productServices";
import ViewDeckleOrder from "../DeckleOrderDrawer/viewDeckleOrder";
import {
  CoversionFactorCMToUnits,
  CoversionFactorUnitsToCM,
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import styled from "styled-components";
import {
  changeProductionJobCardState,
  getJumboReelDetailsById,
  replanJobcard,
} from "../../../Services/productionPlanningServices";
import ParentReelJobCardDrawer from "../../ProductionPlanning/ProductionJobCards/JobcardDrawers/parentReelJobCardDrawer";
import PrintIcon from "../../../Assets/Icons/printer2.svg";
import { toHandlePOName } from "../../../Utils/helper/helper";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import CreateNewSolution from "../DeckleResults/createNewSolution";
import LottieAnimation from "../../../Lottie";
import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
const Panes = Tabs.TabPane;

const gridViewData = [
  {
    label: <Iconmoon icon="grid-chart" size={20} color="#EA655B" />,
    value: "grid",
  },
  { label: <Iconmoon icon="table" size={20} color="#EA655B" />, value: "list" },
];

const CardShimmerStyle = styled.div`
  .ant-card-body {
    position: relative;
    z-index: 0;
    overflow: hidden;
    height: 100%;
    padding: 0px;
  }
  .ant-skeleton-element .ant-skeleton-button {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element .ant-skeleton-input {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element {
    width: 100%;
  }
  .ant-skeleton-element .ant-skeleton-image {
    min-width: 0px;
    width: 100%;
  }
`;

const JobCardDetailData = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();
  const [ordersFullFilledList, setOrdersFullFilledList] = useState([]);
  const [ordersUnFullFilledList, setOrdersUnFullFilledList] = useState([]);
  // const [posList, setPosList] = useState([]);
  // console.log(location.state)
  const [jobId, setJobId] = useState(
    location.state ? location.state.id : searchParams.get("id")
  );
  const [jobCard, setJobCard] = useState();
  const [disablePrint, setDisablePrint] = useState(true);
  const [jobcardCode, setJobcardcode] = useState();
  const [acceptedSolution, setAcceptedSolution] = useState({
    name: null,
    key: null,
    solution: null,
  });
  // const [cylinderData, setCylinderData] = useState();
  //List view state
  // const [gridView, setGridView] = useState(true);
  // const [cylinderColumnHead, setCylinderColumnHead] = useState([]);
  // const [loadingColumnHead, setLoadingColumnHead] = useState(true);
  const [solutionId, setSolutionId] = useState("1");
  //List view state ends here
  const [isVisibleApproveModal, setIsVisibleApproveModal] = useState(false);
  const [visibleRejectDrawer, setVisibleRejectDrawer] = useState(false);
  const [visibleMarkCompletedModal, setVisibleMarkCompletedModal] =
    useState(false);
  const [visibleCancelProduction, setVisibleCancelProduction] = useState(false);
  const [visibleStartProduction, setVisibleStartProduction] = useState(false);
  const [actionResponse, setActionResponse] = useState({});
  const [reFetch, setReFetch] = useState(true);
  const [toaster, setToaster] = useState(false);
  const [viewOrder, setViewOrder] = useState(false);
  const [orderDetailsList, setOrderDetailsList] = useState();
  const [selectedOrderNo, setSelectedOrderNo] = useState();
  const [selectedOrder, setSelectedOrder] = useState();
  const [intermediateData, setIntermediateData] = useState([]);
  const [isParentReelCancelled, setIsParentReelCancelled] = useState(false);
  const [totalFulfilledOrders, setTotalFulfilledOrders] = useState(0);
  const [totalUnfulfilledOrders, setTotalUnfulfilledOrders] = useState(0);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [jobCardDetailsListForPrint, setJobCardDetailsListForPrint] =
    useState();
  const [isPrintDisabled, setIsPrintDisabled] = useState(false);
  const [isMapJumboLoading, setIsMapJumboLoading] = useState(false);
  const [jumboReelData, setJumboReelData] = useState();
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [settingsData, setSettingsData] = useState(
    JSON.parse(localStorage.getItem("setting-data"))
  );
  const [activeTab, setActiveTab] = useState("1");
  const [sizeFulfillmentDetailsList, setSizeFulfillmentDetailsList] =
    useState();
  const [unitData, setUnitData] = useState();
  const [selectedParentReel, setSelectedParentReel] = useState();
  const [viewParentReelJobCardDrawer, setViewParentReelJobCardDrawer] =
    useState(false);
  const [isProduced, setIsProduced] = useState(false);
  const [jobcardType, setJobCardType] = useState(
    location.state ? location.state.jobcardType : searchParams.get("type")
  );
  const [sizeExpanded, setSizeExpanded] = useState(false);
  const [orderManagementSettings, setOrderManagementSettings] = useState(JSON.parse(localStorage.getItem("order-management-settings")));
  const [deckleManagementSettings, setDeckleManagementSettings] = useState();
  const [dynamicStock,setDynamicStock]=useState([])
  //Changes related ERP integration -------------------------------------------------------

  const [showAimation, setShowAimation] = useState({});
  const [
    createNewSolutionFormValuesForSizes,
    setCreateNewSolutionFormValuesForSizes,
  ] = useState();
  const [formValuesForStock, setFormValuesForStock] = useState({});
    const [stockSizes, setStockSizes] = useState([]);
  const [jobIndex, setJobIndex] = useState(0);
  const [optimizePartition, setOptimizePartition] = useState(false);
  const [minimizeOverfulfillment, setMinimizeOverfulfillment] = useState(false);
  const [createNewSolutionClicked, setCreateNewSolutionClicked] = useState({
    isClicked: false,
    index: -1,
  });
  const [jobCardDetailsList, setJobCardDetailsList] = useState([]);
  const [rerendering, setRerendering] = useState(false);
  const [solId, setSolId] = useState("1");
  const [failedNewSol, setFailedNewSol] = useState({});
  const [ordersIdList, setOrderIdList] = useState([]);
  const [isReplanClicked, setIsReplanClicked] = useState(false);
  const [isCreateNewSolutionClicked, setIsCreateNewSolutionClicked] = useState(false);
  //-----------------------------------------------------------------------------------

  const columnBlacklist =
    settingsData?.settings?.orders_page?.tables?.jobcard_orders || [];
  const format = settingsData?.settings?.product_spec?.format || "";
  const printJobCardDetails = () => {
    navigate("./viewer", {
      state: {
        jobId: jobId,
        jobcardCode: getJCCode(jobCard.jobcard_code),
        solution: acceptedSolution.key,
        orderDetailsList: jobCardDetailsListForPrint,
        type: "singleStage",
        machineType: "rewinder",
      },
    });
  };

  const getJCCode = (str) => {
    if (str) {
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  };

  const tabChange = (key) => setActiveTab(key);
  const approveJobCard = (jobId) => {
    approveRejectJobCard({ id: jobId, state: "approved" })
      .then((response) => {
        setActionResponse({ error: response.error, msg: response.msg });
        setReFetch(true);
      })
      .catch((error) => {
        setActionResponse({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        console.log(error);
      });
  };
  const onPaginationChange = (page, pageSize, isUnfulfilled) => {
    // console.log(page, pageSize);
    setCurrentPage(page);
    setPageSize(pageSize);
    // isUnfulfilled && setIsUnfulfilledTab(true);
  };

  function onChange(pagination, filters, sorter, extra) {
    // console.log("params", pagination, filters, sorter, extra);
    if (pagination) onPaginationChange(pagination.current, pagination.pageSize);
  }
  const showToaster = () => {
    setToaster(true);
    setTimeout(() => setToaster(false), 4000);
  };

  const approveModalShow = () => {
    setIsVisibleApproveModal(true);
  };

  const approveModalClose = () => {
    setIsVisibleApproveModal(false);
  };

  const approveModalConfirm = (value) => {
    approveJobCard(value);
    setIsVisibleApproveModal(false);
    setReFetch(true);
    showToaster();
  };

  const showRejectDrawer = () => {
    setVisibleRejectDrawer(true);
  };

  const closeRejectDrawer = () => {
    setVisibleRejectDrawer(false);
  };

  const showViewDrawer = (value, record) => {
    setSelectedOrderNo(value);
    setSelectedOrder(record);
    setViewOrder(true);
  };

  const closeViewDrawer = () => {
    setViewOrder(false);
  };

  const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

  //A switch case function to return states of a job card.
  const jobcardState = (state) => {
    switch (state) {
      case "pending":
        return "Pending for approval";
      case "approved":
        return "Approved";
      case "rejected":
        return "Rejected";
      case "in_production":
        return "In Production";
      case "cancel":
        return "Production Cancelled";
      case "complete":
        return "Complete";
      case "hold":
        return "On Hold";
      case "produced":
        return "Produced";
      case "active":
        return "Active";
      case "under_review":
        return "Under Review";
      case "cancelled":
        return "Cancelled";
      default:
        return;
    }
  };

  //api-call to get the details of a specific jobcard
  const getJobCardDetailsById = async () => {
    try {
      const response = await getJobCardsById(jobId);
      if (response?.jobcard_code) {
        let splittedString = response?.jobcard_code?.split("~");
        setJobcardcode(splittedString?.join(""));
      }
      setJobCard(response);
      setJobCardType(response.type);
      const selectedState =
        response.state === "complete" ||
        response.state === "in_production" ||
        response.state === "hold" ||
        response.state === "cancel";
      if (response?.jobcard.solution_1.status === "accept") {
        // console.log("acc1", acceptedSolution);
        setAcceptedSolution({
          name: "Solution 1",
          key: 1,
          solution: response.jobcard.solution_1,
        });
        // console.log(response.jobcard.solution_1.data)
        // console.log(response.state)
        setIsParentReelCancelled(
          response.jobcard.solution_1.data.parent_reel_cancelled &&
            selectedState
        );
        setSizeFulfillmentDetails(response.jobcard.solution_1.data);
        let tempOrdersArray = [];
        response.jobcard.solution_1.data.orders.map((order) => {
          if (order.item_type == "order") {
            tempOrdersArray.push(order.order_id);
          }
        });
        setOrderIdList(tempOrdersArray);
      } else if (response?.jobcard.solution_2.status === "accept") {
        // console.log("acc2", acceptedSolution);
        setAcceptedSolution({
          name: "Solution 2",
          key: 2,
          solution: response.jobcard.solution_2,
        });
        setIsParentReelCancelled(
          response.jobcard.solution_2.data.parent_reel_cancelled &&
            selectedState
        );
        setSizeFulfillmentDetails(response.jobcard.solution_2.data);
        let tempOrdersArray = [];
        response.jobcard.solution_2.data.orders.map((order) => {
          if (order.item_type == "order") {
            tempOrdersArray.push(order.order_id);
          }
        });
        setOrderIdList(tempOrdersArray);
      }
    } catch (error) {
      console.log("Error in accepting solution", error.response);
    }
  };

  const setSizeFulfillmentDetails = (data) => {
    // Use data.orders instead of data.sizes to prevent multiple orders with the same size from being merged
    const orders = data.orders?.filter(order => order.item_type !== "trim_loss") || [];
    let sizeFulfillmentList = orders.map((size, index) => {
      return {
        key: index + 1,
        type: size.item_type === "stock" ? "Stock" : "Order",
        size: `${size.size} ${
          size.lateral_size ? "X " + size.lateral_size : ""
        } ${" "} ${
          size.units && size.units.size
            ? lengthUnit[size.units.size]?.displayName?.toUpperCase()
            : "CM"
        }`,
        plannedReels: size.fulfilled + size.unfulfilled,
        plannedWeight:
          (size.fulfilled_weight + size.unfulfilled_weight).toFixed(3) +
          " " +
          (size?.units && size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
            : "T"),
        fulflilledReels: size.fulfilled,
        fulflilledWeight:
          size.fulfilled_weight.toFixed(3) +
          " " +
          (size?.units && size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
            : "T"),
        unFulflilledReels: size.unfulfilled,
        unFulflilledWeight:
          size.unfulfilled_weight.toFixed(3) +
          " " +
          (size?.units && size?.units?.unfulfilled_weight
            ? weightUnit[
                size.units.unfulfilled_weight
              ]?.displayName?.toUpperCase()
            : "T"),
        reelSpecification: size?.diameter_fulfillment?.map((diaItem) => {
          const reelOd = diaItem.reel_od;
          const coreId = diaItem.core_id;
          const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
          const fulfilledValue = diaItem.fulfilled;
          const fulfilledWeightUnit = size?.units?.fulfilled_weight
            ? capitalize(
                size.units?.fulfilled_weight
                  ? weightUnit[size?.units?.fulfilled_weight].displayName
                  : "t"
              )
            : "";
          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
        }),
      };
    });

    setSizeFulfillmentDetailsList(sizeFulfillmentList);
  };
  const getIntermediateListItems = (
    ordersList,
    jobcard,
    solution,
    isNewSolution
  ) => {
    // console.log(jobIndex, jobCardDetailsList[jobIndex]);
    getIntermediateList(ordersList, jobcard, solution).then((response) => {
      // console.log(response);
      if (!response) return;
      const intermediateDataTemp = response?.map((item, index) => {
        const reelSpecifications = item.reel_specification?.map((spec) => {
          const outerDiameters = Array.isArray(spec?.reel_od)
            ? spec.reel_od.join(", ")
            : spec.reel_od;
          return `${outerDiameters} / ${
            spec?.core_id
          } (${spec?.fulfilled_weight?.toFixed(3)} ${weightUnit[
            spec?.units?.fulfilled_weight
          ]?.displayName?.toUpperCase()}, ${spec.fulfilled}R)`;
        });

        return {
          key: index,
          srno: index + 1,
          reel_size: `${item.reel_size} ${lengthUnit[
            item.units.reel_size
          ]?.displayName?.toUpperCase()}`,
          order_size: item.length
            ? `${item.width} ${lengthUnit[
                item.units.width
              ]?.displayName?.toUpperCase()} x ${item.length} ${lengthUnit[
                item.units.length
              ]?.displayName?.toUpperCase()}`
            : `${item.width} ${lengthUnit[
                item.units.width
              ]?.displayName?.toUpperCase()}`,
          grain: item.grain,
          quantity: `${item.quantity?.toFixed(3)} ${weightUnit[
            item.units.quantity
          ]?.displayName?.toUpperCase()}`,
          reelSpecification: reelSpecifications?.join("\n"),
        };
      });

      setIntermediateData(intermediateDataTemp);
    });
  };

  const printJobCard = (record) => {
    navigate("./print-job-card/pdf", {
      state: {
        jobId: jobId,
        jobcardCode: getJCCode(jobCard.jobcard_code),
        machine_type: record.jobcard.group.machines[0].machine_type
          ? record.jobcard.group.machines[0].machine_type
          : "rewinder",
      },
    });
  };

  const showParentReelJobCard = (id, isProduced) => {
    setSelectedParentReel(id);
    setViewParentReelJobCardDrawer(true);
    setIsProduced(isProduced);
  };

  const routeChange = (record) => {
    navigate("../job-card-details/print-parent-reel/pdf", {
      state: {
        jobId: jobId,
        parentReel: record.parentReel,
        machine_type: record.machine_type ? record.machine_type : "rewinder",
      },
    });
  };

  const onCloseParentReelCancel = (id) => {
    setViewParentReelJobCardDrawer(false);
    // showCancelProduction(id);
  };

  const closeParentReelJobCard = () => {
    setSelectedParentReel();
    setViewParentReelJobCardDrawer(false);
    setIsProduced(false);
  };

  const fetchOrders = async () => {
    setIsFetchingData(true);
    let orderList = [];
    const ordersList = acceptedSolution.solution.data.orders
      ?.filter((order) => {
        return order.item_type == "order";
      })
      .map((item) => item.order_id);
    const fulfilledOrdersList = acceptedSolution.solution.data.orders
      ?.filter((order) => {
        return order.item_type == "order" && order.fulfilled_weight > 0;
      })
      ?.map((item) => item.order_id);

    const unfulfilledOrdersList = acceptedSolution.solution.data.orders
      ?.filter((order) => {
        return order.item_type == "order" && order.unfulfilled_weight > 0;
      })
      ?.map((item) => item.order_id);

    setTotalFulfilledOrders(acceptedSolution.solution.data.orders
      ?.filter((order) => {
        return  order.fulfilled_weight > 0;
      }).length);
    setTotalUnfulfilledOrders(unfulfilledOrdersList.length);
    // console.log(tota)
    // if()
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    ordersList &&
      (await getOrdersList([
        ...fulfilledOrdersList,
        ...unfulfilledOrdersList,
      ])
        .then((response) => {
          orderList = response.data.map((item, index) => {
            const orderData = acceptedSolution.solution.data.orders.filter(
              (order) => parseFloat(order.order_id) === item.number
            )[0];

            // console.log(orderData);
            let unitValue = orderData.units ? orderData.units : {};
            unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
              ? unitValue?.fulfilled_weight
              : unitData.units_management.weight.default;
            return {
              key: index + 1,
              pono: `${item.po}`,
              overfulfillmentPercentage: `${(((orderData.fulfilled_weight/orderData.requirement)-1)*100).toFixed(2)}%`,
              category: item?.category,
              sono: item?.so,
              orderno: `${item.number}`,
              type: "Order",
              productspec: item?.product_spec,
              customercode: item.customer,
              customername: item.customer_name,
              customer_alias: item.customer_alias,
              size: `${item.width}${
                item.length ? ` x ${item.length}` : ""
              } ${" "} ${
                item?.units && item?.units?.width
                  ? lengthUnit[item.units.width]?.displayName?.toUpperCase()
                  : "CM"
              }`,
              productInfo: item.product_info,
              plannedReels: orderData.requirement,
              plannedreel: orderData.requirement,
              plannedWeight:
                orderData.requirement?.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.requirement
                  ? weightUnit[
                      orderData.units.requirement
                    ]?.displayName.toUpperCase()
                  : "T"),
              fulflilledReels: orderData.fulfilled,
              fulflilledWeight:
                orderData.fulfilled_weight.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.fulfilled_weight
                  ? weightUnit[
                      orderData.units.fulfilled_weight
                    ]?.displayName?.toUpperCase()
                  : "T"),
              unFulflilledReels: orderData.unfulfilled,
              unFulflilledWeight:
                orderData.unfulfilled_weight.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.unfulfilled_weight
                  ? weightUnit[
                      orderData.units.unfulfilled_weight
                    ]?.displayName?.toUpperCase()
                  : "T"),
              priority: jobCard.jobcard.group.orders.filter(
                (order) => order.order_id === item.number
              )[0].forced,
              deliverydate:
                item.category === "so"
                  ? "-"
                  : moment(item.delivery_date).format("DD MMM YYYY"),
              remarks: item.remarks,
              reel_od: item.reel_od,
              core_id: item.core_id,
              consignee_name: item.consignee_name,
              consignee_code: item.consignee_code,
              reelSpecification: orderData?.diameter_fulfillment?.map(
                (diaItem) => {
                  const reelOd = diaItem.reel_od;
                  const coreId = diaItem.core_id;
                  const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
                  const fulfilledValue = diaItem.fulfilled;
                  const fulfilledWeightUnit = capitalize(
                    orderData.units?.fulfilled_weight
                      ? weightUnit[orderData.units?.fulfilled_weight]
                          .displayName
                      : "T"
                  );
                  return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n`;
                }
              ),
              diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                (diaItem, index) => {
                  return {
                    reel_od: diaItem.reel_od,
                    core_id: diaItem.core_id,
                    fulfilled_weight:
                      diaItem.fulfilled_weight -
                      orderData?.cancelled_diameter_fulfillment[index]
                        ?.fulfilled_weight,
                    fulfilled:
                      diaItem.fulfilled -
                      orderData?.cancelled_diameter_fulfillment[index]
                        ?.fulfilled,
                    fulfilledWeightUnit: orderData.units?.fulfilled_weight
                      ? orderData.units?.fulfilled_weight
                      : unitData.units_management.weight.default,
                  };
                }
              ),
              cancelled_diameter_fulfillment:
                orderData?.cancelled_diameter_fulfillment,
              fulfilled_quantity:
                orderData.fulfilled_weight - orderData.cancelled_weight,
              units: unitValue,
              cancelledQty: orderData?.cancelled_diameter_fulfillment?.map(
                (diaItem) => {
                  const reelOd = diaItem.reel_od;
                  const coreId = diaItem.core_id;
                  const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
                  const fulfilledValue = diaItem.fulfilled;
                  const fulfilledWeightUnit = capitalize(
                    orderData.units?.fulfilled_weight
                      ? weightUnit[orderData.units?.fulfilled_weight]
                          .displayName
                      : "T"
                  );
                  return fulfilledWeight && fulfilledValue
                    ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n`
                    : "-";
                }
              ),
            };
          });

          const stockSizesList = acceptedSolution.solution.data.orders
            ?.filter((order) => {
              return order.item_type == "stock";
            })
            .map((item) => item.order_id);

          const dynamicStock = acceptedSolution.solution.data.orders
            ?.filter((order) => {
              return (
                order.item_type == "stock" &&
                (order.creation_type === "dynamic" ||
                  order.creation_type === "required")
              );
            })
            .map((item) => {
              return {
                allowedQuantity: item?.requirement,
                stockSize: item.size,
                isSelected: true,
                ...(item.creation_type === "dynamic" && { isNew: true }),
                ...(item.creation_type === "required" && {
                  isRequired: true,
                  weight_lb: item.requirement_lb,
                  weight_ub: item.requirement_ub,
                  priority_stock : item.priority_stock
                }),
                isEdit: false,
                units: {
                  quantity: item?.units?.fulfilled_weight,
                  width: item?.units?.size,
                  weight_lb: item?.units?.requirement_lb,
                  weight_ub: item?.units?.requirement_ub,
                },
              };
            });
            setDynamicStock(dynamicStock)
          if (stockSizesList.length > 0) {
            getStocksDetailsByIds({ stocks: stockSizesList })
              .then((response) => {
                let sizesList = response.data.map((item, index) => {
                  const orderData =
                    acceptedSolution.solution.data.orders.filter(
                      (order) => order.order_id === item.id
                    )[0];
                  //console.log(orderData);
                  let unitValue = orderData.units ? orderData.units : {};
                  unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
                    ? unitValue?.fulfilled_weight
                    : unitData.units_management.weight.default;

                  return {
                    key: index + 1,
                    pono: "-",
                    orderno: `${item.id}`,
                    overfulfillmentPercentage:`${( ( (orderData.fulfilled_weight/orderData.requirement) -1 )*100).toFixed(2)}%`,
                    type: "Stock",
                    customercode: "-",
                    customername: "-",
                    customer_alias: "-",
                    size: `${item.width}${
                      item.length ? ` x ${item.length}` : ""
                    } ${" "} ${
                      item.units && item.units?.width
                        ? lengthUnit[
                            item.units.width
                          ]?.displayName?.toUpperCase()
                        : "CM"
                    }`,
                    productInfo: item.product_info,
                    productspec: item?.product_spec,
                    plannedReels: "-",
                    plannedreel: orderData.requirement,
                    plannedWeight: "-",
                    fulflilledReels: orderData.fulfilled,
                    fulflilledWeight:
                      orderData.fulfilled_weight.toFixed(3) +
                      " " +
                      (orderData?.units && orderData.units.fulfilled_weight
                        ? weightUnit[orderData.units.fulfilled_weight]
                            ?.displayName
                        : "T"),
                    unFulflilledReels: "-",
                    unFulflilledWeight: "-",
                    priority: false,
                    deliverydate: "-",
                    remarks: item.remarks,
                    external_order_id: item.external_order_id,
                    reel_od: item.reel_od,
                    core_id: item.core_id,
                    consignee_name: "-",
                    consignee_code: "-",
                    consignee: item.consignee_name,
                    reelSpecification: orderData?.diameter_fulfillment?.map(
                      (diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[orderData.units?.fulfilled_weight]
                            ?.displayName
                        );
                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                      }
                    ),
                    diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                      (diaItem, index) => {
                        return {
                          reel_od: diaItem.reel_od,
                          core_id: diaItem.core_id,
                          fulfilled_weight:
                            diaItem.fulfilled_weight -
                            orderData?.cancelled_diameter_fulfillment[index]
                              ?.fulfilled_weight,
                          fulfilled:
                            diaItem.fulfilled -
                            orderData?.cancelled_diameter_fulfillment[index]
                              ?.fulfilled,
                          fulfilledWeightUnit: orderData.units?.fulfilled_weight
                            ? orderData.units?.fulfilled_weight
                            : unitData.units_management.weight.default,
                        };
                      }
                    ),
                    cancelled_diameter_fulfillment:
                      orderData?.cancelled_diameter_fulfillment,
                    fulfilled_quantity:
                      orderData.fulfilled_weight - orderData.cancelled_weight,
                    units: unitValue,
                    cancelledQty:
                      orderData?.cancelled_diameter_fulfillment?.map(
                        (diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            orderData.units?.fulfilled_weight
                              ? weightUnit[orderData.units?.fulfilled_weight]
                                  .displayName
                              : "T"
                          );
                          return fulfilledWeight && fulfilledValue
                            ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n`
                            : "-";
                        }
                      ),
                  };
                });

                setOrderDetailsList([...orderList, ...sizesList]);
                let tempOrdersArray = [];
              })
              .catch((error) => console.log(error));
          } else {
            setOrderDetailsList(orderList);
          }
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setIsFetchingData(false);
        }));
  };
  const fetchOrdersForPrint = async () => {
    setIsPrintDisabled(true);
    let orderList = [];
    const ordersList = acceptedSolution.solution.data.orders
      ?.filter((order) => {
        return order.item_type == "order";
      })
      .map((item) => item.order_id);

    ordersList &&
      (await getOrdersList(ordersList)
        .then((response) => {
          orderList = response.data.map((item, index) => {
            const orderData = acceptedSolution.solution.data.orders.filter(
              (order) => parseFloat(order.order_id) === item.number
            )[0];

            // console.log(orderData);
            let unitValue = orderData.units ? orderData.units : {};
            unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
              ? unitValue?.fulfilled_weight
              : unitData.units_management.weight.default;
            return {
              key: index + 1,
              pono: `${item.po}`,
              category: item?.category,
              sono: item?.so,
              orderno: `${item.number}`,
              type: "Order",
              productspec: item?.product_spec,
              customercode: item.customer,
              customername: item.customer_name,
              customer_alias: item.customer_alias,
              size: `${item.width}${
                item.length ? ` x ${item.length}` : ""
              } ${" "} ${
                item?.units && item?.units?.width
                  ? lengthUnit[item.units.width]?.displayName?.toUpperCase()
                  : "CM"
              }`,
              productInfo: item.product_info,
              orderWeight: `${item?.weight?.toFixed(3)} ${item?.units?.weight?.toUpperCase()}`,
              plannedReels: orderData.requirement,
              plannedreel: orderData.requirement,
              plannedWeight:
                orderData.requirement?.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.requirement
                  ? weightUnit[
                      orderData.units.requirement
                    ]?.displayName.toUpperCase()
                  : "T"),
              fulflilledReels: orderData.fulfilled,
              fulflilledWeight:
                orderData.fulfilled_weight.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.fulfilled_weight
                  ? weightUnit[
                      orderData.units.fulfilled_weight
                    ]?.displayName?.toUpperCase()
                  : "T"),
              unFulflilledReels: orderData.unfulfilled,
              unFulflilledWeight:
                orderData.unfulfilled_weight.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.unfulfilled_weight
                  ? weightUnit[
                      orderData.units.unfulfilled_weight
                    ]?.displayName?.toUpperCase()
                  : "T"),
              priority: jobCard.jobcard.group.orders.filter(
                (order) => order.order_id === item.number
              )[0].forced,
              deliverydate:
                item.category === "so"
                  ? "-"
                  : moment(item.delivery_date).format("DD MMM YYYY"),
              remarks: item.remarks,
              reel_od: item.reel_od,
              core_id: item.core_id,
              consignee_name: item.consignee_name,
              consignee_code: item.consignee_code,
              reelSpecification: orderData?.diameter_fulfillment?.map(
                (diaItem, index) => {
                  const reelOd = diaItem.reel_od;
                  const coreId = diaItem.core_id;
                  // const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
                  // const fulfilledValue = diaItem.fulfilled;
                  const fulfilledWeight = (
                    diaItem.fulfilled_weight -
                    orderData?.cancelled_diameter_fulfillment[index]
                      .fulfilled_weight
                  ).toFixed(3);
                  const fulfilledValue =
                    diaItem.fulfilled -
                    orderData?.cancelled_diameter_fulfillment[index].fulfilled;
                  const fulfilledWeightUnit = capitalize(
                    orderData.units?.fulfilled_weight
                      ? weightUnit[orderData.units?.fulfilled_weight]
                          .displayName
                      : "T"
                  );
                  return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n`;
                }
              ),
              diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                (diaItem, index) => {
                  return {
                    reel_od: diaItem.reel_od,
                    core_id: diaItem.core_id,
                    fulfilled_weight:
                      diaItem.fulfilled_weight -
                      orderData?.cancelled_diameter_fulfillment[index]
                        ?.fulfilled_weight,
                    fulfilled:
                      diaItem.fulfilled -
                      orderData?.cancelled_diameter_fulfillment[index]
                        ?.fulfilled,
                    fulfilledWeightUnit: orderData.units?.fulfilled_weight
                      ? orderData.units?.fulfilled_weight
                      : unitData.units_management.weight.default,
                  };
                }
              ),
              cancelled_diameter_fulfillment:
                orderData?.cancelled_diameter_fulfillment,
              fulfilled_quantity:
                orderData.fulfilled_weight - orderData.cancelled_weight,
              units: unitValue,
              cancelledQty: orderData?.cancelled_diameter_fulfillment?.map(
                (diaItem) => {
                  const reelOd = diaItem.reel_od;
                  const coreId = diaItem.core_id;
                  const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
                  const fulfilledValue = diaItem.fulfilled;
                  const fulfilledWeightUnit = capitalize(
                    orderData.units?.fulfilled_weight
                      ? weightUnit[orderData.units?.fulfilled_weight]
                          .displayName
                      : "T"
                  );
                  return fulfilledWeight && fulfilledValue
                    ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n`
                    : "-";
                }
              ),
              external_order_id: item.external_order_id,
            };
          });

          const stockSizesList = acceptedSolution.solution.data.orders
            ?.filter((order) => {
              return order.item_type == "stock";
            })
            .map((item) => item.order_id);

             const dynamicStock= acceptedSolution.solution.data.orders
            ?.filter((order) => {
              return order.item_type == "stock" && (order.creation_type==='dynamic' ||  order.creation_type==='required')
            }).map((item) => {
              return {
                  
            allowedQuantity: item?.requirement,
            stockSize: item.size,
            isSelected: true,
            isEdit: false,
            ...(item.creation_type === "dynamic" && { isNew: true }),
                ...(item.creation_type === "required" && {
                  isRequired: true,
                  weight_lb: item.requirement_lb,
                  weight_ub: item.requirement_ub,
                  priority_stock : item.priority_stock
                }),
            units: {
              quantity: item?.units?.fulfilled_weight,
              width: item?.units?.size,
              weight_lb: item?.units?.requirement_lb,
              weight_ub: item?.units?.requirement_ub,
            }
                }  });
            setDynamicStock(dynamicStock)
          if (stockSizesList.length > 0) {
            getStocksDetailsByIds({ stocks: stockSizesList })
              .then((response) => {
                let sizesList = response.data.map((item, index) => {
                  const orderData =
                    acceptedSolution.solution.data.orders.filter(
                      (order) => order.order_id === item.id
                    )[0];
                  //console.log(orderData);
                  let unitValue = orderData.units ? orderData.units : {};
                  unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
                    ? unitValue?.fulfilled_weight
                    : unitData.units_management.weight.default;

                  return {
                    key: index + 1,
                    pono: "-",
                    orderno: `${item.id}`,
                    type: "Stock",
                    customercode: "-",
                    customername: "-",
                    customer_alias: "-",
                    size: `${item.width}${
                      item.length ? ` x ${item.length}` : ""
                    } ${" "} ${
                      item.units && item.units?.width
                        ? lengthUnit[
                            item.units.width
                          ]?.displayName?.toUpperCase()
                        : "CM"
                    }`,
                    productInfo: item.product_info,
                    productspec: item?.product_spec,
                    plannedReels: "-",
                    plannedreel: orderData.requirement,
                    plannedWeight: "-",
                    fulflilledReels: orderData.fulfilled,
                    fulflilledWeight:
                      orderData.fulfilled_weight.toFixed(3) +
                      " " +
                      (orderData?.units && orderData.units.fulfilled_weight
                        ? weightUnit[orderData.units.fulfilled_weight]
                            ?.displayName
                        : "T"),
                    unFulflilledReels: "-",
                    unFulflilledWeight: "-",
                    priority: false,
                    deliverydate: "-",
                    remarks: "",
                    reel_od: item.reel_od,
                    core_id: item.core_id,
                    consignee_name: "-",
                    consignee_code: "-",
                    consignee: item.consignee_name,
                    reelSpecification: orderData?.diameter_fulfillment?.map(
                      (diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[orderData.units?.fulfilled_weight]
                            ?.displayName
                        );
                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                      }
                    ),
                    diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                      (diaItem, index) => {
                        return {
                          reel_od: diaItem.reel_od,
                          core_id: diaItem.core_id,
                          fulfilled_weight:
                            diaItem.fulfilled_weight -
                            orderData?.cancelled_diameter_fulfillment[index]
                              ?.fulfilled_weight,
                          fulfilled:
                            diaItem.fulfilled -
                            orderData?.cancelled_diameter_fulfillment[index]
                              ?.fulfilled,
                          fulfilledWeightUnit: orderData.units?.fulfilled_weight
                            ? orderData.units?.fulfilled_weight
                            : unitData.units_management.weight.default,
                        };
                      }
                    ),
                    cancelled_diameter_fulfillment:
                      orderData?.cancelled_diameter_fulfillment,
                    fulfilled_quantity:
                      orderData.fulfilled_weight - orderData.cancelled_weight,
                    units: unitValue,
                    cancelledQty:
                      orderData?.cancelled_diameter_fulfillment?.map(
                        (diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            orderData.units?.fulfilled_weight
                              ? weightUnit[orderData.units?.fulfilled_weight]
                                  .displayName
                              : "T"
                          );
                          return fulfilledWeight && fulfilledValue
                            ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n`
                            : "-";
                        }
                      ),
                  };
                });

                setJobCardDetailsListForPrint([...orderList, ...sizesList]);
              })
              .catch((error) => console.log(error));
          } else {
            setJobCardDetailsListForPrint(orderList);
          }
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setIsPrintDisabled(false);
        }));
  };
  const handleDropdownClick = async (record, key) => {
    try {
      switch (key) {
        case "sendForReview": // sendForReview
          const response1 = await changeProductionJobCardState({
            id: jobId,
            state: "under_review",
          });
          // setUnderReviewJobCards([...underReviewJobcards, record]);
          // setGridView(true);
          setReFetch(true);
          showToaster();

          break;

        case "markCancelled": // markCancelled
          const response2 = await changeProductionJobCardState({
            id: jobId,
            state: "cancel",
          });
          // setCancelledJobCards([...cancelledJobcards, record]);
          // setGridView(true);
          setReFetch(true);
          showToaster();

          break;

        case "markCompleted": // markCompleted
          const response3 = await changeProductionJobCardState({
            id: jobId,
            state: "complete",
          });
          // setCompleteCards([...completeCards, record]);
          // setGridView(true);
          setReFetch(true);
          showToaster();
          break;

        case "replan":

          const response4 = await replanJobcard({
            jobcard: jobId,
            // state: "complete",
          });
          setIsReplanClicked(true);
          break;
        default:
          console.warn("Unknown dropdown key:", key);
      }
    } catch (error) {
      console.error("Error handling dropdown click:", error);
      setActionResponse({
        error: error.response.data.error,
        msg: error.response.data.msg,
      })
      showToaster();
    }
  };

  //CHanges related to ERP Integration
 const handleOptimizePartitionChange = (isChecked) => {
   setOptimizePartition(isChecked);
 };
 const handleMinimizeOverfulfillmentChange = (isChecked) => {
   setMinimizeOverfulfillment(isChecked);
 };
 const getJobCardsListDetails = (
   jobcardIds,
   parentJobCardId = 0,
   uuid = ""
 ) => {
   let newsolcnt = false;
   getJobCardsDetails({ jobcards: jobcardIds })
     .then((response) => {
       if (!createNewSolutionClicked.isClicked) {
         const tempJobcardDetailsList = jobCardDetailsList;
         tempJobcardDetailsList &&
           response?.map((jobs) => {
             let cnt = 0;
             tempJobcardDetailsList?.map((job) => {
               if (job.id === jobs.id) {
                 cnt++;
               }
             });
             if (!cnt) tempJobcardDetailsList.push(jobs);
           });
         setJobCardDetailsList(
           tempJobcardDetailsList ? tempJobcardDetailsList : response
         );
         setRerendering(!rerendering);
       } else {
         newsolcnt = true;
         let detailsList = jobCardDetailsList;
         let filteredJobCardIndex = detailsList.findIndex(function (
           jobCardDetails
         ) {
           return jobCardDetails.uuid == uuid;
         });
         if (filteredJobCardIndex !== -1) {
           detailsList[filteredJobCardIndex]["newlyCreatedJobCardsDetails"] =
             response;
         } else {
           console.error(`No matching job card found for uuid: ${uuid}`);
         }
         // detailsList[filteredJobCardIndex]["newlyCreatedJobCardsDetails"] =
         //   response;
         setJobCardDetailsList(detailsList);
         setCreateNewSolutionClicked({ isClicked: false, index: -1 });
         setRerendering(!rerendering);
       }
       let stockMachineValue = formValuesForStock?.[jobIndex];
       // stockMachineValue["min_deckle_length"] =
       //   response[0].jobcard.group.machines[0].deckle_size_lb;
       // stockMachineValue["max_deckle_length"] =
       //   response[0].jobcard.group.machines[0].deckle_size_ub +
       //   (response[0].jobcard.group.machines[0].left_edge_trim +
       //   response[0].jobcard.group.machines[0].right_edge_trim) * CoversionFactorUnitsToCM[response[0].jobcard.group.machines[0].units?.right_edge_trim] * CoversionFactorCMToUnits[response[0].jobcard.group.machines[0].units?.deckle_size_ub];
       // stockMachineValue["maximum_cutters"] =
       //   response[0].jobcard.group.machines[0].original_cutters;
       // stockMachineValue["effective_deckle_length"] =
       //   response[0].jobcard.group.machines[0].effective_deckle_length;
       // stockMachineValue["left_edge_trim"] =
       //   response[0].jobcard.group.machines[0].left_edge_trim;
       // stockMachineValue["right_edge_trim"] =
       //   response[0].jobcard.group.machines[0].right_edge_trim;
       // stockMachineValue["units"] =
       //   response[0].jobcard.group.machines[0].units;
       const rewinderMachine = response[0]?.jobcard?.group?.machines?.find(
         (machine) => machine.machine_type === "rewinder"
       );
       if (rewinderMachine) {
         const {
           deckle_size_lb,
           deckle_size_ub,
           left_edge_trim,
           right_edge_trim,
           original_cutters,
           effective_deckle_length,
           units,
           machine_type,
           machine_code,
         } = rewinderMachine;

         const rightEdgeTrimConversionFactor =
           CoversionFactorUnitsToCM[units.right_edge_trim];
         const deckleSizeUbConversionFactor =
           CoversionFactorCMToUnits[units.deckle_size_ub];

         const minDeckleLength = deckle_size_lb;
         const maxDeckleLength =
           deckle_size_ub +
           (left_edge_trim + right_edge_trim) *
             rightEdgeTrimConversionFactor *
             deckleSizeUbConversionFactor;

         stockMachineValue = {
           ...stockMachineValue,
           min_deckle_length: minDeckleLength,
           max_deckle_length: maxDeckleLength,
           maximum_cutters: original_cutters,
           effective_deckle_length: effective_deckle_length,
           left_edge_trim: left_edge_trim,
           right_edge_trim: right_edge_trim,
           units: units,
         };
       }

       setFormValuesForStock({
         ...formValuesForStock,
         [jobIndex]: stockMachineValue,
       });

       const orderIds = [];
       // console.log(response);
       // response.forEach((item) => {
       //   item.jobcard?.group?.orders?.map((order) => {
       //     orderIds.push(order.order_id);
       //   });
       // });
       // // console.log(orderIds);
       // setOrderIdList(orderIds);
     })
     .catch((error) => console.log(error))
     .finally(() => {
       newsolcnt && setSolId("3");
       newsolcnt && setSolutionId("3");
     });
 };
  
const callReadyNewSolutionSingleStage = async (jobCardId) => {
  while (true) {
    try {
      const jobCard = await readyJobCardSinglestageNewSolution();
      const readyData = jobCard || {};
      const jobcardOutputMapping = readyData?.jobcard_output_mapping || {};
      const parentId = parseInt(jobCardId, 10);
      const mappedEntry =
        jobcardOutputMapping[parentId] ?? jobcardOutputMapping[String(parentId)];
      const mappedNewId =
        typeof mappedEntry === "object" ? mappedEntry?.jobcard : mappedEntry;
      const newJobcardIds =
        mappedNewId !== undefined && mappedNewId !== null
          ? [mappedNewId]
          : [];

      if (newJobcardIds.length > 0) {
        setShowAimation((prev) => ({ ...prev, [jobIndex]: false }));
        navigate("../deckle-match-result", {
          state: {
            jobCards: {
              ...readyData,
              jobcards: newJobcardIds,
              failed_groups: readyData?.failed_groups || [],
              total_groups: readyData?.total_groups || newJobcardIds.length,
            },
            parentJCid:jobCardId,
            type:'replan',
            jobcardType:jobcardType,
            isDummyJC: jobCardDetailsList[jobIndex].is_dummy,
            
          },
        });
        break;
         
      }
    } catch (error) {
      // Keep polling until backend is ready for this new-solution mapping.
      console.error("Error while polling new solution status:", error);
    }

    await new Promise((resolve) => setTimeout(resolve, 5000));
  }
};

  const onClickCreateSolution = async (e, jobCardId, uuid, ind) => {
    setActiveTab("1");
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    // setShowAimation(true);
    setShowAimation((prev) => ({ ...prev, [ind]: true }));
    let sizes = [];
    setCreateNewSolutionFormValuesForSizes(e);
    if (e.selectedSizes.length > 0) {
      e.selectedSizes.forEach((size) => {
        let sizeObject = {
          id: size.stockSizeId,
          size: parseFloat(size.stockSize),
          allowed_quantity: parseFloat(size.allowedQuantity),
          planned_weight: parseFloat(size.plannedWeight),
          units: size.units,
          creation_type: size.creation_type,
          type: "reel",
          creation_type: size.creation_type,
          ...(size.creation_type == 'required' && {weight_lb : size.weight_lb,
            weight_ub : size.weight_ub,
            priority_stock : size.priority_stock,
          }),
        };
        sizes.push(sizeObject);
      });
    }

    let updatedFormValues = {};
    updatedFormValues["max_deckle_length"] = e.maxDeckleLength
      ? parseFloat(e.maxDeckleLength)
      : formValuesForStock?.[jobIndex]?.max_deckle_length;
    updatedFormValues["min_deckle_length"] = e.minDeckleLength
      ? parseFloat(e.minDeckleLength)
      : formValuesForStock?.[jobIndex]?.min_deckle_length;
    updatedFormValues["left_edge_trim"] = e.minWidth
      ? parseFloat(e.minWidth)
      : formValuesForStock?.[jobIndex]?.left_edge_trim;
    updatedFormValues["right_edge_trim"] = e.maxWidth
      ? parseFloat(e.maxWidth)
      : formValuesForStock?.[jobIndex]?.right_edge_trim;
    updatedFormValues["maximum_cutters"] = e.cutters
      ? parseFloat(e.cutters)
      : formValuesForStock?.[jobIndex]?.maximum_cutters;
    updatedFormValues["effective_deckle_length"] = e.cutters
      ? parseFloat(e.effectiveDeckleLength)
      : "";
    updatedFormValues["units"] = {
      max_deckle_length: e.deckleLengthUnit,
      min_deckle_length: e.deckleLengthUnit,
      left_edge_trim: e.widthUnit,
      right_edge_trim: e.widthUnit,
      effective_deckle_length: e.effectiveDeckleLengthUnit,
    };
    setFormValuesForStock({
      ...formValuesForStock,
      [jobIndex]: updatedFormValues,
    });

    let request = {
      jobcard: jobCardId,
      run_type: "selected_sizes",
      machine_selection_data: {
        maximum_deckle_size: e.maxDeckleLength
          ? parseFloat(e.maxDeckleLength)
          : formValuesForStock?.[jobIndex]?.max_deckle_length,
        minimum_deckle_size: e.minDeckleLength
          ? parseFloat(e.minDeckleLength)
          : formValuesForStock?.[jobIndex]?.min_deckle_length,
        left_edge_trim: e.minWidth
          ? parseFloat(e.minWidth)
          : formValuesForStock?.[jobIndex]?.left_edge_trim,
        right_edge_trim: e.maxWidth
          ? parseFloat(e.maxWidth)
          : formValuesForStock?.[jobIndex]?.right_edge_trim,
        maximum_cutters: e.cutters
          ? parseFloat(e.cutters)
          : formValuesForStock?.[jobIndex]?.maximum_cutters,
        effective_deckle_length: e.effectiveDeckleLength
          ? parseFloat(e.effectiveDeckleLength)
          : "",
        units: {
          maximum_deckle_size: e.deckleLengthUnit,
          minimum_deckle_size: e.deckleLengthUnit,
          left_edge_trim: e.widthUnit,
          right_edge_trim: e.widthUnit,
          effective_deckle_length: e.effectiveDeckleLengthUnit,
        },
      },
      sizes: sizes,
      optimize_unique_partitions: optimizePartition,
      minimize_overfulfillment: minimizeOverfulfillment,
    };
    try {
      let jobCard = await createNewSolution(request);
      await callReadyNewSolutionSingleStage(jobCardId,)
      // setShowAimation(false);
      setFailedNewSol((prev) => {
        return { ...prev, [jobIndex]: false };
      });
    } catch (error) {
      let jobcardResp = [];

      let jobCard = await getAlgorithmCompletionStatus();
      let response = await getFailedGroups({
        failed_groups: jobCard.data.failed_groups,
      });
      
 setActionResponse({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        showToaster();
    //  navigate("../deckle-match-result", {
    //   state:{
    //     jobCards: jobCard.data,
    //     parentJCid:jobCardId,
    //     type:'replan',
    //     jobcardType:jobcardType,
    //     isDummyJC: jobCardDetailsList[jobIndex].is_dummy
    //   }
    //  })
      // setShowAimation(false);
      let detailsList = jobCardDetailsList;
      let filteredJobCardIndex = detailsList.findIndex(function (
        jobCardDetails
      ) {
        return jobCardDetails.uuid == uuid;
      });

      let data = {
        orders: [],
        partitions: [],
        sizes: [],
        summary: {},
      };
      let jobcardData = {
        created_at: response[0].created_at,
        uuid: response[0].uuid,
        id: response[0].id,
        user_id: response[0].user_id,
        updated_at: response[0].updated_at,
        jobcard: {
          group: response[0].group,
          solution_1: { data },
          solution_2: { data },
        },
      };
      jobcardResp.push(jobcardData);
      // console.log(jobcardData)
      detailsList[filteredJobCardIndex]["newlyCreatedJobCardsDetails"] =
        jobcardResp;
      setJobCardDetailsList(detailsList);
      setSolId("3");
      setSolutionId("3");
      // fetchOrders("current_solution", jobcardData.jobcard);
      // console.log(detailsList)
      setFailedNewSol((prev) => {
        return { ...prev, [jobIndex]: true };
      });
      // setRerendering(!rerendering);
      setCreateNewSolutionClicked({ isClicked: false, index: -1 });
    } finally {
      setCreateNewSolutionClicked({ isClicked: false, index: -1 });
      setIsCreateNewSolutionClicked(false);
      setTimeout(() => {
        setShowAimation((prev) => ({ ...prev, [ind]: false }));
      }, 4000);
    }
  };
  // const onClickCreateSolution = async (e, jobCardId, uuid, jobIndex) => {
  //   setActiveTab('1');
  //   setCurrentSummaryTab('1');
  //   setSizeExpanded(false);
  //   setSizeExpanded(false);
  //   setSizeExpanded(false);
  //   setSizeExpanded(false);
  //   setShowAimation((prev) => {
  //     return { ...prev, [jobIndex]: true };
  //   });

  //   // Track this parent as "in progress" (null) every time user clicks create solution,
  //   // including "new solution on existing new solution".
  //   setNewSolutionByParentId((prev) => ({ ...(prev || {}), [jobCardId]: null }));
    
  //   newSolutionAppliedNewIdsByParentRef.current = {
  //     ...(newSolutionAppliedNewIdsByParentRef.current || {}),
  //     [jobCardId]: [],
  //   };
  //   // Also clear any "resolved" marker for this parent so animation/polling behaves correctly.
  //   const nextResolved = new Set(newSolutionResolvedParentsRef.current || []);
  //   nextResolved.delete(jobCardId);
  //   newSolutionResolvedParentsRef.current = nextResolved;
  //   if (newSolutionMappingRef.current?.[jobCardId] !== undefined) {
  //     const nextMap = { ...(newSolutionMappingRef.current || {}) };
  //     delete nextMap[jobCardId];
  //     newSolutionMappingRef.current = nextMap;
  //   }

  //   let sizes = [];
  //   setCreateNewSolutionFormValuesByJobCard((prev) => ({
  //     ...prev,
  //     [jobCardId]: e,
  //   }));
  //   if (e.selectedSizes.length > 0) {
  //     e.selectedSizes.forEach((size) => {
  //       let sizeObject = {
  //         id: size.stockSizeId,
  //         //size: size.stockSize,
  //         allowed_quantity: parseFloat(size.allowedQuantity),
  //         reels: size.reels,
  //         planned_weight: parseFloat(size.plannedWeight),
  //         type: size.type,
  //         sheets: size.sheets,
          
  //         ...((size.type === "sheet") && {lateral_size: size.length,
  //           grain: size.grain,
  //         }),
  //         ...((size.type === "reel") && {
  //           grain: null,
  //         }),
  //         size: size.width,
  //         mixed_grain: false,
  //         ...(size.creation_type === "required" && {
  //           weight_lb: parseFloat(size.weight_lb),
  //           weight_ub: parseFloat(size.weight_ub),
            
  //           priority_stock: size.priority_stock,
  //         }),
  //         units: {
  //           ...size.units,
            
  //           lateral_size: size.units.length,
  //           size: size.units.width ,
  //         },         
  //         creation_type: size.creation_type,
  //       };
  //       sizes.push(sizeObject);
  //     });
  //   }
  //   let updatedFormValues = { ...formValuesForStock?.[jobIndex] };
  //   updatedFormValues["max_deckle_length"] = e.maxDeckleLength
  //     ? parseFloat(e.maxDeckleLength)
  //     : updatedFormValues?.max_deckle_length;
  //   updatedFormValues["min_deckle_length"] = e.minDeckleLength
  //     ? parseFloat(e.minDeckleLength)
  //     : updatedFormValues?.min_deckle_length;
  //   updatedFormValues["left_edge_trim"] = e.minWidth
  //     ? parseFloat(e.minWidth)
  //     : updatedFormValues?.left_edge_trim;
  //   updatedFormValues["right_edge_trim"] = e.maxWidth
  //     ? parseFloat(e.maxWidth)
  //     : updatedFormValues?.right_edge_trim;
  //   updatedFormValues["maximum_cutters"] = e.cutters
  //     ? parseFloat(e.cutters)
  //     : updatedFormValues?.cutters;
  //   updatedFormValues["effective_deckle_length"] = e.cutters
  //     ? parseFloat(e.effectiveDeckleLength)
  //     : "";
  //   updatedFormValues["units"] = {
  //     max_deckle_length: e.deckleLengthUnit,
  //     min_deckle_length: e.deckleLengthUnit,
  //     left_edge_trim: e.widthUnit,
  //     right_edge_trim: e.widthUnit,
  //     effective_deckle_length: e.deckleLengthUnit,
  //     deckle_size_ub: e.deckleLengthUnit,
  //     deckle_size_lb: e.deckleLengthUnit,
  //   };
  //   updatedFormValues["max_deckle_length_cutter"] = e.maxDeckleLengthCutter
  //     ? parseFloat(e.maxDeckleLengthCutter)
  //     : updatedFormValues?.max_deckle_length;
  //   updatedFormValues["min_deckle_length_cutter"] = e.minDeckleLengthCutter
  //     ? parseFloat(e.minDeckleLengthCutter)
  //     : updatedFormValues?.min_deckle_length;
  //   updatedFormValues["left_edge_trim_cutter"] = e.minWidthCutter
  //     ? parseFloat(e.minWidthCutter)
  //     : updatedFormValues?.left_edge_trim;
  //   updatedFormValues["right_edge_trim_cutter"] = e.maxWidthCutter
  //     ? parseFloat(e.maxWidthCutter)
  //     : updatedFormValues?.right_edge_trim;
  //   updatedFormValues["maximum_cutters_cutter"] = e.cuttersCutter
  //     ? parseFloat(e.cuttersCutter)
  //     : updatedFormValues?.cuttersCutter;
  //   updatedFormValues["effective_deckle_length_cutter"] =
  //     e.effectiveDeckleLengthCutter
  //       ? parseFloat(e.effectiveDeckleLengthCutter)
  //       : "";
  //   updatedFormValues["min_dia_cutter"] = parseFloat(e.min_dia_cutter);
  //   updatedFormValues["max_dia_cutter"] = parseFloat(e.max_dia_cutter);
  //   updatedFormValues["min_chop_cutter"] = parseFloat(e.min_chop_cutter);
  //   updatedFormValues["max_chop_cutter"] = parseFloat(e.max_chop_cutter);
  //   updatedFormValues["max_trim_intermediate_cutter"] = parseFloat(
  //     e.max_trim_intermediate_cutter
  //   );
  //   updatedFormValues["units_cutter"] = {
  //     ...e.units_cutter,
  //     max_deckle_length: e.deckleLengthUnitCutter,
  //     min_deckle_length: e.deckleLengthUnitCutter,
  //     left_edge_trim: e.widthUnitCutter,
  //     right_edge_trim: e.widthUnitCutter,
  //     effective_deckle_length: e.deckleLengthUnitCutter,
  //     minimum_reel_dia: e.reel_dia_unit_cutter,
  //     maximum_reel_dia: e.reel_dia_unit_cutter,
  //     max_chop_size: e.chopUnit,
  //     min_chop_cutter: e.chopUnit,
  //     deckle_size_ub: e.deckleLengthUnitCutter,
  //     deckle_size_lb: e.deckleLengthUnitCutter,
  //     allowed_trim: e.max_trim_intermediate_unit_cutter,
  //   };

  //   setFormValuesForStock({ ...formValuesForStock, [jobIndex]: updatedFormValues });
  //   const rewinderMachine = jobCardDetailsList[
  //     jobIndex
  //   ].jobcard?.group?.machines?.find(
  //     (machine) => machine.machine_type === "rewinder"
  //   );
  //   const cutterMachine = jobCardDetailsList[
  //     jobIndex
  //   ].jobcard?.group?.machines?.find(
  //     (machine) => machine.machine_type === "cutter"
  //   );

  //   let request = {
  //     [`${jobCardDetailsList[jobIndex]?.isFailedJobcard ? "failed_group": "jobcard"}`]: jobCardDetailsList[jobIndex]?.isFailedJobcard? jobCardDetailsList[jobIndex]?.failedGroupId : location?.state?.parentJCid || jobCardId,
  //     run_type: "selected_sizes",
  //     machine_selection_data: [
  //       {
  //         ...rewinderMachine,
  //         maximum_deckle_size: e.maxDeckleLength
  //           ? parseFloat(e.maxDeckleLength)
  //           : updatedFormValues?.max_deckle_length,
  //         minimum_deckle_size: e.minDeckleLength
  //           ? parseFloat(e.minDeckleLength)
  //           : updatedFormValues?.min_deckle_length,
  //         left_edge_trim: e.minWidth
  //           ? parseFloat(e.minWidth)
  //           : updatedFormValues?.left_edge_trim,
  //         right_edge_trim: e.maxWidth
  //           ? parseFloat(e.maxWidth)
  //           : updatedFormValues?.right_edge_trim,
  //         maximum_cutters: e.cutters
  //           ? parseFloat(e.cutters)
  //           : updatedFormValues?.maximum_cutters,
  //         effective_deckle_length: e.effectiveDeckleLength
  //           ? parseFloat(e.effectiveDeckleLength)
  //           : "",
  //         units: {
  //           maximum_deckle_size: e.deckleLengthUnit,
  //           minimum_deckle_size: e.deckleLengthUnit,
  //           left_edge_trim: e.widthUnit,
  //           right_edge_trim: e.widthUnit,
  //           effective_deckle_length: e.deckleLengthUnit,
  //         },
  //       },
  //       {
  //         ...cutterMachine,
  //         maximum_deckle_size: e.maxDeckleLengthCutter >=0
  //           ? parseFloat(e.maxDeckleLengthCutter)
  //           : updatedFormValues?.max_deckle_length_cutter,
  //         minimum_deckle_size: e.minDeckleLengthCutter >=0
  //           ? parseFloat(e.minDeckleLengthCutter)
  //           : updatedFormValues?.min_deckle_length_cutter,
  //         left_edge_trim: e.minWidthCutter >=0
  //           ? parseFloat(e.minWidthCutter)
  //           : updatedFormValues?.left_edge_trim_cutter,
  //         right_edge_trim: e.maxWidthCutter >=0
  //           ? parseFloat(e.maxWidthCutter)
  //           : updatedFormValues?.right_edge_trim_cutter,
  //         maximum_cutters: e.cuttersCutter >=0
  //           ? parseFloat(e.cuttersCutter)
  //           : updatedFormValues?.maximum_cutters_cutter,
  //         effective_deckle_length: e.effectiveDeckleLengthCutter
  //           ? parseFloat(e.effectiveDeckleLengthCutter)
  //           : "",
  //         minimum_reel_dia: parseFloat(e.min_dia_cutter),
  //         maximum_reel_dia: parseFloat(e.max_dia_cutter),
  //         max_chop_size: parseFloat(e.max_chop_cutter),
  //         min_chop_size: parseFloat(e.min_chop_cutter),
  //         allowed_trim: parseFloat(e.max_trim_intermediate_cutter),
  //         units: {
  //           maximum_deckle_size: e.deckleLengthUnitCutter,
  //           minimum_deckle_size: e.deckleLengthUnitCutter,
  //           left_edge_trim: e.widthUnit_cutter,
  //           right_edge_trim: e.widthUnit_cutter,
  //           effective_deckle_length: e.deckleLengthUnitCutter,
  //           minimum_reel_dia: e.reel_dia_unit_cutter,
  //           maximum_reel_dia: e.reel_dia_unit_cutter,
  //           max_chop_size: e.chopUnit,
  //           min_chop_size: e.chopUnit,
  //           allowed_trim: e.max_trim_intermediate_unit_cutter,
  //         },
  //       },
  //     ],
  //     sizes: sizes,
  //     optimize_unique_partitions: optimizePartition,
  //     minimize_overfulfillment: minimizeOverfulfillment,
  //   };
  //   await handleCutterReelDiaChange(e, cutterMachine);
  //   try {
  //     setCreateNewSolutionClicked(true);
  //     // This API triggers async creation; it does not return the jobcard data immediately.
  //     await createNewSolutionMultistage(request);
  //     // allow user to start new solution for other jobcards while this one cooks
  //     setCreateNewSolutionClicked(false);
  //     newSolutionPollingActiveRef.current = true;
  //     setIsNewSolutionPolling(true);
  //     // Initiate Ready API immediately on click (do not wait for the next 5s interval).
  //     pollReadyNewSolutionOnce();
  //     newSolutionPendingParentsRef.current = new Set([
  //       ...(newSolutionPendingParentsRef.current || new Set()),
  //       jobCardId,
  //     ]);
  //     setShowAimation((prev) => ({ ...prev, [jobIndex]: true }));
  //     setCurrentSolution("3");

  //     setFailedNewSol((prev) => {
  //       return { ...prev, [jobIndex]: false };
  //     });
  //   } catch (error) {
  //     let jobcardResp = [];
  //     let response = [];

  //     // console.log(error?.response?.data?.data?.group_id, error?.response?.data?.data, response);
  //     if(error?.response?.data?.data?.group_id){
  //       response.push(error?.response?.data?.data);
  //     }
  //     else {
  //       let jobCard = await getAlgorithmCompletionStatusMultiStage();
  //        response = await getFailedGroups({
  //         failed_groups: jobCard.data.failed_groups,
  //       });
  //     }

  //     setFailedNewSol((prev) => {
  //       return { ...prev, [jobIndex]: true };
  //     });

  //     let detailsList = jobCardDetailsList;
  //     let filteredJobCardIndex = detailsList.findIndex(function (
  //       jobCardDetails
  //     ) {
  //       return jobCardDetails.uuid == uuid;
  //     });

  //     let data = {
  //       orders: [],
  //       partitions: [],
  //       sizes: [],
  //       summary: {},
  //     };

  //     let jobcardData = {};

  //     if (!response.length) {
  //       jobcardData = {
  //         created_at: detailsList[filteredJobCardIndex].created_at,
  //         uuid: detailsList[filteredJobCardIndex].uuid,
  //         id: detailsList[filteredJobCardIndex].id,
  //         user_id: detailsList[filteredJobCardIndex].user_id,
  //         updated_at: detailsList[filteredJobCardIndex].updated_at,
  //         jobcard: {
  //           group: detailsList[filteredJobCardIndex].jobcard.group,
  //           solution_1: {
  //             data: {
  //               exception:
  //                 "Job card could not be created for the input.Please check the input and try again",
  //             },
  //           },
  //           solution_2: {
  //             data: {
  //               exception:
  //                 "Job card could not be created for the input.Please check the input and try again",
  //             },
  //           },
  //         },
  //       };
  //     } else {
  //       jobcardData = {
  //         created_at: response[0].created_at,
  //         uuid: response[0].uuid,
  //         id: response[0].id,
  //         user_id: response[0].user_id,
  //         updated_at: response[0].updated_at,
  //         jobcard: {
  //           group: error?.response?.data?.data?.group_id? response[0] : response[0].group,
  //           solution_1: { data },
  //           solution_2: { data },
  //         },
  //       };
  //     }
  //     jobcardResp.push(jobcardData);
  //     //set isSucessful to false if the new solution for failedJC is failed
  //     detailsList[filteredJobCardIndex] = {
  //       ...detailsList[filteredJobCardIndex],
  //       isSuccessful: false, 
  //       newlyCreatedJobCardsDetails :jobcardResp
  //     };
  //     setJobCardDetailsList(detailsList);
  //     if(showAimation[jobIndex])
  //       setCurrentSolution("3");
  //     // setSolutionId("3");
  //     // fetchOrders("current_solution", jobcardData.jobcard);
  //   } finally {
  //     setTimeout(() => {
  //       setShowAimation((prev) => {
  //         // if it is still pending, keep animation
  //         const pending = newSolutionPendingParentsRef.current;
  //         if (pending && pending.has(jobCardId)) return prev;
  //         return { ...prev, [jobIndex]: false };
  //       });
  //     }, 4000);
  //   }
  // };

  // Column heads
  // const columnsHead = [
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "8%",
  //     fixed: "left",
  //     align: "center",
  //     render: (text, record) => {
  //       const value =
  //         record.category === "po"
  //           ? toHandlePOName(record.pono)
  //           : record.category === "so"
  //           ? toHandlePOName(record.sono)
  //           : toHandlePOName(record.pono);

  //       return (
  //         <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
  //           {value
  //             ?.match(/.{1,15}/g)
  //             ?.map((chunk, index) => (
  //               <span key={index}>
  //                 {chunk}
  //                 <br />
  //               </span>
  //             ))}
  //         </span>
  //       );
  //     }

  //   },
  //   {
  //     title: "Order No/Stock No",
  //     dataIndex: "orderno",
  //     width: "10%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Type",
  //     dataIndex: "type",
  //     width: "6%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "10%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customername}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias||'-'}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_name",
  //     width: "10%",
  //     render: (text, record) => (
  //       record?.consignee||'-'
  //     )
  //   },
  //   {
  //     title: (
  //       <div>
  //         Product Spec
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     dataIndex: "productspec",
  //     width: "14%",
  //   },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "9%",
  //   },
  //   // {
  //   //   title: "Planned Reels",
  //   //   dataIndex: "plannedReels",
  //   //   width: "8%",
  //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   // },
  //   {
  //     title: "Planned Quantity",
  //     dataIndex: "plannedWeight",
  //     width: "10%",
  //   },
  //   // {
  //   //   title: "Fulfilled Reels",
  //   //   dataIndex: "fulflilledReels",
  //   //   width: "8%",
  //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   // },
  //   {
  //     title: "Fulfilled Quanitity",
  //     dataIndex: "fulflilledWeight",
  //     width: "10%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5%",
  //   // },
  //   {
  //     title: "REEL SPECIFICATION",
  //     dataIndex: "reelSpecification",
  //     width: "22%",
  //     render: (text) => (
  //       <div
  //         dangerouslySetInnerHTML={{
  //           __html: String(text).replace(/\n/g, "<br />"),
  //         }}
  //       />
  //     ),
  //   },
  //   {
  //     title: "Del Date",
  //     dataIndex: "deliverydate",
  //     width: "10%",
  //   },

  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQty",
  //     width: "22%",
  //     render: (text) =>
  //       isParentReelCancelled ? (
  //         <div
  //           dangerouslySetInnerHTML={{
  //             __html: String(text).replace(/\n/g, "<br />"),
  //           }}
  //         />
  //       ) : (
  //         "-"
  //       ),
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "10%",
  //     render: (text, record) =>
  //       record.type === "Order" && (
  //         <div className="actionBtn">
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={record.remarks}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button style={{ cursor: "default" }}>
  //                 <Iconmoon icon="message" size={16} color="#EA655B" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         </div>
  //       ),
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "10%",
  //     render: (text, record) =>
  //       record.type === "Order" && (
  //         <div className="actionBtn">
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"View details of this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button onClick={() => showViewDrawer(record.orderno,record)}>
  //                 <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         </div>
  //       ),
  //     align: "center",
  //   },
  // ];
  const intermediateColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "srno",
      width: 6,
      fixed: "left",
      align: "center",
    },
    {
      title: "Reel Size",
      dataIndex: "reel_size",
      width: 8,
      fixed: "left",
      align: "center",
    },
    {
      title: "Order Size (WxL)",
      dataIndex: "order_size",
      width: 10,
      align: "center",
    },
    {
      title: "Matched Grain",
      dataIndex: "grain",
      width: 8,
      align: "center",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: 8,
      align: "center",
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: 16,
      align: "center",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
  ];

  // const unfulfilledColumnsHead = [
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "7%",
  //     fixed: "left",
  //     align: "center",
  //     render: (text, record) => {
  //       const value =
  //         record.category === "po"
  //           ? toHandlePOName(record.pono)
  //           : record.category === "so"
  //           ? toHandlePOName(record.sono)
  //           : toHandlePOName(record.pono);

  //       return (
  //         <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
  //           {value
  //             ?.match(/.{1,15}/g)
  //             ?.map((chunk, index) => (
  //               <span key={index}>
  //                 {chunk}
  //                 <br />
  //               </span>
  //             ))}
  //         </span>
  //       );
  //     }
  //   },
  //   {
  //     title: "Order No/Stock No",
  //     dataIndex: "orderno",
  //     width: "10%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Type",
  //     dataIndex: "type",
  //     width: "7%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "10%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customername}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias||'-'}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_name",
  //     width: "10%",
  //     render: (text, record) => (
  //       record?.consignee||'-'
  //     )
  //   },
  //   {
  //     title: (
  //       <div>
  //         Product Spec
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     dataIndex: "productspec",
  //     width: "14%",
  //   },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "9%",
  //   },
  //   // {
  //   //   title: "Planned Reels",
  //   //   dataIndex: "plannedReels",
  //   //   width: "8%",
  //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   // },
  //   {
  //     title: "Planned Quantity",
  //     dataIndex: "plannedWeight",
  //     width: "10%",
  //   },
  //   // {
  //   //   title: "Unfulfilled Reels",
  //   //   dataIndex: "unFulflilledReels",
  //   //   width: "8%",
  //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   // },
  //   {
  //     title: "Unfulfilled Quantity",
  //     dataIndex: "unFulflilledWeight",
  //     width: "10%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5%",
  //   // },
  //   {
  //     title: "Del Date",
  //     dataIndex: "deliverydate",
  //     width: "10%",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "10%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "10%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View details of this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button onClick={() => showViewDrawer(record.orderno,record)}>
  //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  // ];
  const sizeFulfillmentColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "key",
      width: "7%",
      fixed: "left",
      align: "center",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "7%",
    //   fixed: "left",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
      title: "UnFulfilled/(Overfulfilled) Quantity",
      dataIndex: "unFulflilledWeight",
      width: "10%",
      render: (text, record) => {
        const parsedValue = parseFloat(text?.split(" ")[0]);
        const positiveValue = Math.abs(parsedValue);
        return parsedValue < 0 ? (
          <div>
            ({positiveValue} {text?.split(" ")[1]})
          </div>
        ) : (
          text
        );
      },
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "20%",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    // {
    //   title: "Fulfilled Reels",
    //   dataIndex: "fulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    // {
    //   title: "Unfulfilled Reels",
    //   dataIndex: "unFulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
  ];

  const mapJumboReelColumns = [
    {
      title: "Combination No.",
      dataIndex: "combination_no",
      width: "9%",
      align: "center",
    },
    {
      title: "Combination",
      dataIndex: "combinations",
      width: "25%",
      sorter: {
        compare: (a, b) => {},
      },
      render: (text, record) => (
        <div className="combination-rl">
          {record.machine_type !== "cutter" ? (
            <h4>
              {text?.map(
                (item, index, array) =>
                  `${item.width} ${index + 1 !== array.length ? "+" : ""}`
              )}
              {record.priority && <span dataset="Priority">Priority</span>}
            </h4>
          ) : (
            <h4>
              {`(`}
              {text?.map(
                (item, index) =>
                  `${item.width} ${index + 1 !== text.length ? "+" : ""}`
              )}{" "}
              {`) X ${text[0].length}`}
              {record.priority && <span dataset="Priority">Priority</span>}
            </h4>
          )}

          {record.core_id &&
          record.reel_od &&
          record.machine_type !== "cutter" ? (
            <p>Parent Reel: {record.parentReel}</p>
          ) : (
            <p>Parent Set: {record.parentReel}</p>
          )}
        </div>
      ),
    },
    {
      title: "Reel OD/ Core OD",
      dataIndex: "diaValue",
      width: "9%",
      align: "center",
    },
    {
      title: "Chop Size",
      dataIndex: "chop_size",
      width: "9%",
      align: "center",
      render: (text, record) =>
        `${text} ${" "} ${
          record?.units && record?.units?.length
            ? lengthUnit[record.units.length]?.displayName?.toUpperCase()
            : "CM"
        }`,
    },
    {
      title: "D.Com.Width",
      dataIndex: "comWidth",
      width: "9%",
      align: "center",
      render: (text, record) =>
        `${text} ${" "} ${
          record?.units && record?.units?.d_com_width
            ? lengthUnit[record.units.d_com_width]?.displayName?.toUpperCase()
            : "CM"
        }`,
    },
    {
      title: "TRIM LOSS",
      dataIndex: "trimLoss",
      width: "8%",
      align: "center",
      render: (text, record) =>
        `${text.toFixed(3)} ${" "} ${
          record?.units && record?.units?.trim_loss
            ? lengthUnit[record.units.trim_loss]?.displayName?.toUpperCase()
            : "CM"
        }`,
    },
    {
      title: (
        <div>
          NET TRIM LOSS
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={"Net trim loss including the edge trim"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "netTrimLoss",
      width: "8%",
      align: "center",
      render: (text, record) =>
        `${text.toFixed(3)} ${" "} ${
          record?.units && record?.units?.net_trim_loss
            ? lengthUnit[record.units.net_trim_loss]?.displayName?.toUpperCase()
            : "CM"
        }`,
    },
    {
      title: (
        <div>
          EARLIEST DELIVERY <br /> DATE
        </div>
      ),
      dataIndex: "deliverydate",
      width: "19%",
      align: "center",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      render: (text) => moment(text).format("DD MMM YYYY"),
    },
    {
      title: "MAPPED JUMBO ROLL",
      dataIndex: "mappedJumboRoll",
      width: "15%",
      align: "center",
      render: (text) => {
        return text.length === 0
          ? "-"
          : text?.map(
              (item, index, array) =>
                `${item.number}${index + 1 != array.length ? ", " : ""}`
            );
      },
    },
    {
      title: "PRODUCTION STATUS",
      dataIndex: "status",
      width: "13%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.reel_od && record.core_id
                  ? text === "Produced"
                    ? "The production of this parent reel is completed"
                    : text === "Mapped"
                    ? "This parent reel is mapped to jumbo roll for rewinding"
                    : text === "Not Mapped"
                    ? "This parent reel is not mapped to jumbo roll yet"
                    : text === "Cancelled"
                    ? "The production of this parent reel is cancelled"
                    : null
                  : text === "Produced"
                  ? " The production of this parent set is completed"
                  : text === "Mapped"
                  ? "The parent set has been mapped to a jumbo roll"
                  : text === "Not Mapped"
                  ? "The parent set is not mapped to a jumbo roll yet"
                  : text === "Cancelled"
                  ? "The production of this parent set is cancelled"
                  : text === "Rejected"
                  ? "The production of this parent set is rejected "
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {text}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "ACTIONS",
      dataIndex: "action",
      width: "15%",
      align: "center",
      render: (text, record) => (
        <div
          className="actionBtn"
          // style={{ display: "flex", justifyContent: "end" }}
        >
          {record.status == "Mapped" &&
            jobCard.state !== "hold" &&
            jobCard.state !== "complete" && (
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"Print details of the parent reel"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button onClick={() => routeChange(record)}>
                    <img style={{ width: "20px" }} src={PrintIcon} />
                  </Button>
                </Tooltip>
              </Styled>
            )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View parent reel details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() =>
                  showParentReelJobCard(
                    record.parentReel,
                    record.status === "Produced" || record.status === "Rejected"
                  )
                }
              >
                <Iconmoon icon="file-view" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
    },
  ];

  const fullColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
            ? toHandlePOName(record.sono)
            : toHandlePOName(record.pono);

        return (
          <span
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
            }}
          >
            {value?.match(/.{1,15}/g)?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
          </span>
        );
      },
    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "10%",
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "6%",
      fixed: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "10%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_name",
      width: "10%",
      render: (text, record) => record?.consignee || "-",
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    // {
    //   title: "Fulfilled Reels",
    //   dataIndex: "fulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Fulfilled Quanitity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "22%",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
    {
      title: "Del Date",
      dataIndex: "deliverydate",
      width: "10%",
    },

    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQty",
      width: "22%",
      render: (text) =>
        isParentReelCancelled ? (
          <div
            dangerouslySetInnerHTML={{
              __html: String(text).replace(/\n/g, "<br />"),
            }}
          />
        ) : (
          "-"
        ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "10%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.remarks}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button style={{ cursor: "default" }}>
                  <Iconmoon icon="message" size={16} color="#EA655B" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno, record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];

  const fullUnfulfilledColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "7%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
            ? toHandlePOName(record.sono)
            : toHandlePOName(record.pono);

        return (
          <span
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
            }}
          >
            {value?.match(/.{1,15}/g)?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
          </span>
        );
      },
    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "10%",
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "10%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_name",
      width: "10%",
      render: (text, record) => record?.consignee || "-",
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    // {
    //   title: "Unfulfilled Reels",
    //   dataIndex: "unFulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Unfulfilled Quantity",
      dataIndex: "unFulflilledWeight",
      width: "10%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
    {
      title: "Del Date",
      dataIndex: "deliverydate",
      width: "10%",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "10%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => showViewDrawer(record.orderno, record)}>
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const orderFulfillmentColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
            ? toHandlePOName(record.sono)
            : toHandlePOName(record.pono);

        return (
          <span
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
            }}
          >
            {value?.match(/.{1,15}/g)?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
          </span>
        );
      },
    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "10%",
      fixed: "left",
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Fulfilled Quanitity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
      title: "Overfulfilment %",
      dataIndex: "overfulfillmentPercentage",
      width: "10%",
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "22%",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "10%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.remarks}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button style={{ cursor: "default" }}>
                  <Iconmoon icon="message" size={16} color="#EA655B" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno, record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];

  const filteredColumns1 = fullColumnsHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns2 = fullUnfulfilledColumnsHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );

  const columnsHead = filteredColumns1;
  const unfulfilledColumnsHead = filteredColumns2;

  useEffect(() => {
    setPageSize(10);
    setCurrentPage(1);
  }, [activeTab]);

  useEffect(async () => {
    const orderMangSettings = await getWorkflowSettings("order_management");
    setOrderManagementSettings(orderMangSettings.data);
    const deckleMangSettings = await getWorkflowSettings("deckle_management");
    setDeckleManagementSettings(deckleMangSettings?.data);
  }, []);

  useEffect(() => {
    if (!acceptedSolution) return;
    if (acceptedSolution.solution) fetchOrdersForPrint();
    const ordersList = acceptedSolution?.solution?.data?.orders
      ?.filter((order) => {
        return order.item_type == "order";
      })
      .map((item) => item.order_id);
    ordersList &&
      getIntermediateListItems(
        ordersList,
        jobId,
        acceptedSolution?.key === 1 ? "solution_1" : "solution_2"
      );
  }, [acceptedSolution]);

  useEffect(async () => {
    try {
      const unitData = await getUnitData();
      if (!unitData.error) {
        setUnitData(unitData.data);
      }
    } catch (err) {
      console.log(err);
    }
    if (location.state) setSearchParams({ id: location.state.id });
  }, []);

  useEffect(() => {
    if (reFetch) {
      getJobCardDetailsById();
      getJobCardsListDetails([jobId]);
      setReFetch(false);
    }
  }, [reFetch]);

  useEffect(() => {
    if (acceptedSolution.solution) fetchOrders();
  }, [acceptedSolution, pageSize, currentPage]);

  useEffect(() => {
    if (!orderManagementSettings) return;
    if (orderManagementSettings.fetch_balance_quantity.value) return;
    if (
      jobCard?.state === "in_production" ||
      jobCard?.state === "complete" ||
      jobCard?.state === "hold"
    ) {
      setIsMapJumboLoading(true);
      getJumboReelDetailsById(jobId)
        .then((response) => {
          setJumboReelData(
            response.data.data?.map((item) => {
              const reelOdValue = item.reel_od
                ? `${item.reel_od} ${
                    jobCard.jobcard.group.grouping_params.units &&
                    jobCard.jobcard.group.grouping_params.units.reel_od
                      ? lengthUnit[
                          jobCard.jobcard.group.grouping_params.units.reel_od
                        ]?.displayName.toUpperCase()
                      : "CM"
                  }`
                : "0"; // If item.reel_od doesn't exist, set the value to "0"
              const coreIdValue = item.core_id
                ? `${item.core_id} ${
                    jobCard.jobcard.group.grouping_params.units &&
                    jobCard.jobcard.group.grouping_params.units.core_id
                      ? lengthUnit[
                          jobCard.jobcard.group.grouping_params.units.core_id
                        ]?.displayName.toUpperCase()
                      : "CM"
                  }`
                : "0";
              return {
                leftTrim: item.left_edge_trim,
                rightTrim: item.right_edge_trim,
                deckleWidth: item.deckle_width,
                priority: item.priority,
                parentReel: item.parent_reel.id,
                combinations: item.combinations,
                comWidth: item.d_com_width,
                trimLoss: item.trim_loss,
                netTrimLoss: item.net_trim_loss,
                deliverydate: item.earliest_delivery_date,
                mappedJumboRoll: item?.mapped_jumbo_reels,
                status:
                  item.status === "open"
                    ? "Not Mapped"
                    : item.status === "cancel"
                    ? "Cancelled"
                    : capitalize(item.status),
                core_id: item.core_id,
                reel_od: item.reel_od,
                machine_type: item.machine_type,
                chop_size: item.combinations[0]?.length
                  ? item.combinations[0]?.length
                  : "",
                units: item.units,
                diaValue: `${reelOdValue} / ${coreIdValue}`,
                combination_no: item.combination_no,
              };
            })
          );
        })
        .catch((error) => {
          if (
            error?.response?.data?.msg ===
            "only in production jobcards are required"
          ) {
            setReFetch(true);
            setActiveTab("1");
          }
        })
        .finally(() => setIsMapJumboLoading(false));
    }
  }, [jobCard, orderManagementSettings]);

  useEffect(() => {
    for (let i = 0; i < jumboReelData?.length; i++) {
      if (jumboReelData[i].status !== "Cancel")
        if (jumboReelData[i].status === "Mapped") setDisablePrint(false);
        else {
          setDisablePrint(true);
          break;
        }
    }
    return () => {};
  }, [jumboReelData]);

  return jobCard && acceptedSolution.solution ? (
    isReplanClicked ? (
      <>
        {isCreateNewSolutionClicked?
        <ContentMiddle>
                <div className="imageAnimate">
                  <div className="imageCover">
                    <LottieAnimation lotti={JobcardPrepare} />
                    <p>
                      Our algorithms are cooking a job card for you <br />
                      please wait, it will take less than a minute
                    </p>
                  </div>
                </div>
              </ContentMiddle>
              :
          <CreateNewSolution
          onClickCreateSolution={(e) =>{
            onClickCreateSolution(
              e,
              jobCardDetailsList[jobIndex].id,
              jobCardDetailsList[jobIndex].uuid,
              0
            )
            setIsCreateNewSolutionClicked(true)
          }
          }
          formValuesForStock={formValuesForStock?.[jobIndex]}
          // job.jobcard.group.grouping_params.core_id
          jobCardDetails={jobCardDetailsList[jobIndex].jobcard}
          backButtonClicked={() =>{
            setCreateNewSolutionClicked({
              isClicked: false,
              index: -1,
            })
            setIsReplanClicked(false)
                  cancelJobCard()
          
          }
            
          }
          stockSizesArray={stockSizes}
          setStockSizesArray={setStockSizes}
          createNewSolutionFormValuesForSizes={
            createNewSolutionFormValuesForSizes
          }
          unselectedOrders={
            jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails
              ? jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails[0]
                  ?.jobcard?.group?.unselected_orders
              : jobCardDetailsList[jobIndex]?.jobcard?.group?.unselected_orders
          }
          ordersIdList={ordersIdList}
          optimizePartition={optimizePartition}
          minimizeOverfulfillment={minimizeOverfulfillment}
          onOptimizePartitionChange={handleOptimizePartitionChange}
          onMinimizeOverfulfillmentChange={handleMinimizeOverfulfillmentChange}
          machineData={''}
          jobId={jobCardDetailsList[jobIndex].id}
          solutionId={solutionId}
          completeJCDetails={jobCardDetailsList[jobIndex]}
            solutionType = {'replan'}
            dynamicStock={dynamicStock}
            dummy_orders={jobCardDetailsList[jobIndex].is_dummy}
        />}
      </>
    ) : (
      <RightLayoutContainer>
        {/* {console.log("Jobcard", jobCard)} */}
        <PageTitleComp
          className="marginRightAdg"
          style={{ borderBottom: "0px" }}
        >
          <PageHeader
            ghost={false}
            onBack={() => navigate("../job-cards")}
            // onBack={() => navigate(-2)}
            title="Job Card Details"
            extra={
              jobCard.state == "pending"
                ? [
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={showRejectDrawer}
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
                      Reject Job Card
                    </Button>,
                    <Button
                      key="1"
                      className="themeBtn"
                      onClick={approveModalShow}
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="correct-file" size={14} color="#fff" />
                      Approve Job Card
                    </Button>,
                  ]
                : jobCard.state == "approved"
                ? [
                    // <Button
                    //   key="1"
                    //   className="themeBtn"
                    //   onClick={showStartProductionModal}
                    // >
                    //   <Iconmoon icon="correct-file" size={14} color="#fff" />
                    //   Start Production
                    // </Button>,
                  ]
                : jobCard.state === "in_production"
                ? [
                    // <Button
                    //   key="1"
                    //   className="themeBtn noBg"
                    //   onClick={showCancelProductionModal}
                    // >
                    //   <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
                    //   Cancel Production
                    // </Button>,
                    // <Button
                    //   key="1"
                    //   className="themeBtn"
                    //   onClick={showMarkCompletedModal}
                    // >
                    //   <Iconmoon icon="correct-file" size={14} color="#fff" />
                    //   Mark as Completed
                    // </Button>,
                  ]
                : jobCard.state === "active"
                ? [
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={() =>
                        handleDropdownClick(jobcardCode, "sendForReview")
                      }
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="file-view" size={16} color="#EA4E2C" />
                      Send for Review
                    </Button>,

                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={() =>
                        handleDropdownClick(jobcardCode, "markCancelled")
                      }
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
                      Mark Cancelled
                    </Button>,
                    <Button
                      key="1"
                      className="themeBtn"
                      onClick={() =>
                        handleDropdownClick(jobcardCode, "markCompleted")
                      }
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="correct-file" size={14} color="#fff" />
                      Mark Complete
                    </Button>,
                  ]
                : jobCard.state === "cancel"
                ? []
                : jobCard.state === "under_review"
                ? [
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={() =>
                        handleDropdownClick(jobcardCode, "markCompleted")
                      }
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="correct-file" size={14} color="#EA4E2C" />
                      Mark Complete
                    </Button>,
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={() =>
                        handleDropdownClick(jobcardCode, "markCancelled")
                      }
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
                      Mark Cancelled
                    </Button>,
                    <Button
                      key="1"
                      className="themeBtn"
                      onClick={() => handleDropdownClick(jobcardCode, "replan")}
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="replan" size={16} color="#ffffff" />
                      Re-Plan
                    </Button>,
                  ]
                : null
            }
          ></PageHeader>
        </PageTitleComp>
        <ResultWrap>
          <DetailFields
            className="jobCardView"
            style={{ justifyContent: "flex-start" }}
          >
            <PageTitleComp style={{ borderBottom: "0" }}>
              <PageHeader
                ghost={false}
                // title={`Job Card ${jobcardCode}`}
                title={
                  jobcardCode?.length > 15 ? (
                    <Tooltip placement="bottomLeft" title={jobcardCode}>
                      <h5>{jobcardCode?.slice(0, 16) + "..."}</h5>
                    </Tooltip>
                  ) : (
                    <h5>{jobcardCode}</h5>
                  )
                }
                className="jobCardList-Grid"
              ></PageHeader>

              <div
                className={`jobCardList ${"fullWidth"}`}
                style={{
                  alignSelf: "center",
                  display: "flex",
                  marginTop:
                    isParentReelCancelled && activeTab >= 3 ? "20px" : "34px",
                  // alignContent:'top'
                }}
              >
                <JobCardColorStatus>
                  <div className="statusVal" dataval={jobCard.state}>
                    {jobcardState(jobCard.state)}
                  </div>
                </JobCardColorStatus>
                <div
                  className="statusVal"
                  dataval={jobCard.state}
                  style={{
                    marginLeft:
                      jobCard.state == "pending"
                        ? "12px"
                        : jobCard.state == "rejected"
                        ? "10px"
                        : jobCard.state == "approved"
                        ? "10px"
                        : jobCard.state == "in_production"
                        ? "10px"
                        : jobCard.state == "complete"
                        ? "10px"
                        : jobCard.state=='active'
                        ? "10px"
                        : jobCard.state=='under_review'
                        ? "10px"
                         : jobCard.state=='cancel'
                        ? "10px"
                        : "",
                    marginTop:
                      jobCard.state == "pending" ||
                      jobCard.state=='active'
                        ? "5px"
                        : jobCard.state == "rejected" ||
                          jobCard.state == "approved" ||
                          jobCard.state == "in_production" ||
                          jobCard.state == "complete" ||
                          jobCard.state == "under_review" ||
                          jobCard.state == "cancel" 
                        ? "4px"
                        : "",
                  }}
                >
                  {/* Ply: {jobCard.ply} */}
                </div>
                {activeTab != 2 && orderDetailsList && (
                  <TableList
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    {/*
                  <div className="List-grid-View" onClick={printJobCardDetails}>
                    <div className="printIcon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
                          fill="#605E5C"
                        />
                      </svg>
                    </div>
                  </div>
                  */}
                  </TableList>
                )}
              </div>

              {activeTab == 2 && (
                <Button
                  key="1"
                  className={`noBgBtn ${
                    jobCard.state === "hold" || disablePrint ? "disabled" : ""
                  }`}
                  //disabled={jobCard.state === "hold" || disablePrint}
                  // onClick={() => routeChange(record)}
                  onClick={() => printJobCard(jobCard)}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
                      fill={
                        jobCard.state === "hold" || disablePrint
                          ? "#A19F9D"
                          : "#EA655B"
                      }
                    />
                  </svg>
                  Print Job Card
                </Button>
              )}

              {isParentReelCancelled && activeTab >= 3 && (
                <Col span={9} style={{ display: "absolute" }}>
                  <div
                    className="cancelledSetMessage"
                    style={{
                      display: "flex",
                      justifyContent: "center", // Center content horizontally
                      alignItems: "center", // Center content vertically
                      marginTop: "25px",
                      borderRadius: "4px",
                      backgroundColor: "#f4f0ec",
                      padding: "4px 6px",
                      opacity: 0.95,
                    }}
                  >
                    <div
                      className="centerAlignMeVertically"
                      style={{ padding: "2px 6px 0px 3px" }}
                    >
                      <Iconmoon
                        icon="warning_new"
                        size={20}
                        style={{ color: "#808080" }}
                      />
                    </div>
                    <span style={{ fontSize: "14px", color: "#555555" }}>
                      A few sets were cancelled in this job card. Hence,
                      fulfilled quantity might not be accurate for the cancelled
                      sets.
                    </span>
                  </div>
                </Col>
              )}
            </PageTitleComp>

            <div className="MatchResult JobResulted">
              <Row span={24}>
                {((activeTab != 2 &&
                  ((!sizeExpanded && activeTab == "3") ||
                    (!sizeExpanded && activeTab == "4") ||
                    (!sizeExpanded && activeTab == "5") ||
                    (!sizeExpanded && activeTab == "6"))) ||
                  activeTab == "1") && (
                  <Col
                    span={15}
                    className="pipeBlock"
                    style={{
                      paddingRight: "20px",
                      transform:
                        isParentReelCancelled && activeTab >= 3
                          ? "translateY(-14px)"
                          : "",
                    }}
                  >
                    <JobCardCylinderContainer
                      jobId={jobId}
                      solution={acceptedSolution.key}
                      multiView={false}
                      print_function={
                        orderDetailsList ? printJobCardDetails : null
                      }
                      collapse={props.collapse}
                      isPrintDisabled={isPrintDisabled}
                    />
                  </Col>
                )}
                <Col
                  span={
                    activeTab == 2
                      ? 24
                      : ((sizeExpanded && activeTab == "3") ||
                          (sizeExpanded && activeTab == "4") ||
                          (sizeExpanded && activeTab == "5") ||
                          (sizeExpanded && activeTab == "6")) &&
                        activeTab != "1"
                      ? 24
                      : 9
                  }
                  className="colLayoutBlock leftPostTab"
                >
                  <Tabs
                    defaultActiveKey="1"
                    activeKey={activeTab}
                    onChange={tabChange}
                    className="topPostTab innerPostTab"
                  >
                    <Panes tab="Summary" key="1">
                      <div className="lossValue">
                        <Row span={24} style={{ paddingTop: "10px" }}>
                          <Col span={12}>
                            <div
                              className={
                                isParentReelCancelled
                                  ? "summaryValueCancelled"
                                  : "summaryValue"
                              }
                            >
                              <h5>
                                <span className="trimCut"></span> Trim Loss
                              </h5>
                              <span>
                                {acceptedSolution?.solution
                                  ? acceptedSolution.solution.data.summary.match_trim_loss_percentage.toFixed(
                                      3
                                    )
                                  : ""}{" "}
                                %
                              </span>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div
                              className={
                                isParentReelCancelled
                                  ? "summaryValueCancelled"
                                  : "summaryValue"
                              }
                            >
                              <h5>
                                <span className="trimBox"></span> Fulfilment
                              </h5>
                              <span>
                                {acceptedSolution && acceptedSolution.solution
                                  ? acceptedSolution.solution?.data.summary?.requirement_fulfilled_percentage.toFixed(
                                      3
                                    )
                                  : ""}{" "}
                                %
                              </span>
                            </div>
                          </Col>
                        </Row>
                        <Row span={24}>
                          <Col span={12}>
                            <div
                              className={
                                isParentReelCancelled
                                  ? "summaryValueCancelled"
                                  : "summaryValue"
                              }
                            >
                              <h5>
                                <span className="trimCut"></span> Net Trim Loss:{" "}
                                {acceptedSolution.solution?.data.summary?.net_trim_loss_percentage.toFixed(
                                  3
                                )}{" "}
                                %<p>Loss including edge trim</p>
                              </h5>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div
                              className={
                                isParentReelCancelled
                                  ? "summaryValueCancelled"
                                  : "summaryValue"
                              }
                            >
                              <h5>
                                <span className="trimBox"></span> Weight:{" "}
                                {acceptedSolution.solution?.data.summary?.job_card_weight.toFixed(
                                  3
                                )}{" "}
                                {acceptedSolution.solution?.data.summary
                                  .units &&
                                acceptedSolution.solution?.data.summary.units
                                  .job_card_weight
                                  ? capitalize(
                                      weightUnit[
                                        acceptedSolution.solution?.data.summary
                                          .units.job_card_weight
                                      ]?.displayName
                                    )
                                  : "T"}
                                <p className="lesserSolution">
                                  Total weight of Job Card
                                </p>
                              </h5>
                            </div>
                          </Col>
                        </Row>

                        {isParentReelCancelled && (
                          <>
                            <Row span={24} style={{ paddingTop: "10px" }}>
                              <Col span={12}>
                                <div className={"summaryValue"}>
                                  <h5>
                                    <span className="trimCut"></span>Updated
                                    Trim Loss
                                  </h5>
                                  <span>
                                    {acceptedSolution?.solution
                                      ? acceptedSolution.solution.data.summary.new_match_trim_loss_percentage.toFixed(
                                          3
                                        )
                                      : ""}{" "}
                                    %
                                  </span>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className={"summaryValue"}>
                                  <h5>
                                    <span className="trimBox"></span>Updated
                                    Fulfilled Quantity
                                  </h5>
                                  <span>
                                    {acceptedSolution &&
                                    acceptedSolution.solution
                                      ? acceptedSolution.solution?.data.summary?.new_fulfilled_requirement_weight.toFixed(
                                          3
                                        )
                                      : ""}{" "}
                                    {acceptedSolution &&
                                    acceptedSolution.solution &&
                                    acceptedSolution.solution?.data.summary
                                      ?.units?.fulfilled_requirement_weight
                                      ? capitalize(
                                          weightUnit[
                                            acceptedSolution.solution?.data
                                              .summary?.units
                                              ?.fulfilled_requirement_weight
                                          ].displayName
                                        )
                                      : "T"}
                                  </span>
                                </div>
                              </Col>
                            </Row>

                            <Row span={24}>
                              <Col span={12}>
                                <div className={"summaryValue"}>
                                  <h5>
                                    <span className="trimCut"></span>Updated Net
                                    Trim Loss:{" "}
                                    {acceptedSolution.solution?.data.summary?.new_net_trim_loss_percentage?.toFixed(
                                      3
                                    )}{" "}
                                    %<p>Loss including edge trim</p>
                                  </h5>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className={"summaryValue"}>
                                  <h5>
                                    <span className="trimBox"></span>Updated
                                    Weight:{" "}
                                    {acceptedSolution.solution?.data.summary?.new_job_card_weight?.toFixed(
                                      3
                                    )}{" "}
                                    {acceptedSolution.solution?.data.summary
                                      .units &&
                                    acceptedSolution.solution?.data.summary
                                      .units.job_card_weight
                                      ? capitalize(
                                          weightUnit[
                                            acceptedSolution.solution?.data
                                              .summary.units.job_card_weight
                                          ]?.displayName
                                        )
                                      : "T"}
                                    <p className="lesserSolution">
                                      Total weight of Job Card
                                    </p>
                                  </h5>
                                </div>
                              </Col>
                            </Row>
                          </>
                        )}
                        <Row span={24}>
                          <Col span={12}>
                            <ul>
                              <li>
                                <span>Paper Machine</span>
                                <p>
                                  {jobCard.jobcard.group.machines.map(
                                    (data) => {
                                      return data.name;
                                    }
                                  )}
                                </p>
                              </li>
                              <li>
                                <span>Deckle Width</span>
                                <p>
                                  {jobCard.jobcard.group.machines.map(
                                    (data) => {
                                      return `${(
                                        data.deckle_size_ub +
                                        (data.left_edge_trim +
                                          data.right_edge_trim) *
                                          CoversionFactorUnitsToCM[
                                            jobCard.jobcard.group.machines[0]
                                              .units?.right_edge_trim
                                          ] *
                                          CoversionFactorCMToUnits[
                                            jobCard.jobcard.group.machines[0]
                                              .units?.deckle_size_ub
                                          ]
                                      ).toFixed(
                                        3
                                      )} - ${data.deckle_size_lb.toFixed(3)}`;
                                    }
                                  )}{" "}
                                  {jobCard.jobcard.group.machines[0].units &&
                                  jobCard.jobcard.group.machines[0].units
                                    .deckle_size_ub
                                    ? lengthUnit[
                                        jobCard.jobcard.group.machines[0].units
                                          .deckle_size_ub
                                      ]?.displayName?.toUpperCase()
                                    : "CM"}
                                </p>
                              </li>
                              <li>
                                <span>Edge Trim ( Left / Right )</span>
                                <p>
                                  {`${
                                    jobCard.jobcard.group.machines[0]
                                      .left_edge_trim
                                  } ${
                                    jobCard.jobcard.group.machines[0]?.units &&
                                    jobCard.jobcard.group.machines[0]?.units
                                      .left_edge_trim
                                      ? lengthUnit[
                                          jobCard.jobcard.group.machines[0]
                                            ?.units.left_edge_trim
                                        ]?.displayName?.toUpperCase()
                                      : "CM"
                                  } / ${
                                    jobCard.jobcard.group.machines[0]
                                      .right_edge_trim
                                  } ${
                                    jobCard.jobcard.group.machines[0]?.units &&
                                    jobCard.jobcard.group.machines[0]?.units
                                      .right_edge_trim
                                      ? lengthUnit[
                                          jobCard.jobcard.group.machines[0]
                                            ?.units.right_edge_trim
                                        ]?.displayName?.toUpperCase()
                                      : "CM"
                                  }`}
                                </p>
                              </li>
                              <div
                                style={{
                                  opacity: isParentReelCancelled ? 0.65 : 1,
                                }}
                              >
                                <li>
                                  <span>Number of Unique Sets</span>
                                  <p>
                                    {acceptedSolution &&
                                    acceptedSolution.solution
                                      ? acceptedSolution.solution.data.summary
                                          .unique_partitions
                                      : 0}
                                  </p>
                                </li>
                                <li>
                                  <span>Priority Quantity</span>
                                  <p>
                                    {acceptedSolution &&
                                    acceptedSolution.solution
                                      ? acceptedSolution.solution.data.summary.forced_requirement_fulfilled?.toFixed(
                                          3
                                        )
                                      : 0}{" "}
                                    {acceptedSolution &&
                                    acceptedSolution?.solution?.data?.summary
                                      ?.units?.forced_requirement_fulfilled
                                      ? capitalize(
                                          weightUnit[
                                            acceptedSolution?.solution?.data
                                              ?.summary?.units
                                              ?.forced_requirement_fulfilled
                                          ].displayName
                                        )
                                      : "T"}
                                  </p>
                                </li>
                              </div>
                              {isParentReelCancelled && (
                                <>
                                  <li>
                                    <span>Updated Number of Unique Sets</span>
                                    <p>
                                      {acceptedSolution &&
                                      acceptedSolution.solution
                                        ? acceptedSolution.solution.data.summary
                                            ?.new_unique_partitions
                                        : 0}
                                    </p>
                                  </li>
                                  <li>
                                    <span>Updated Priority Quantity</span>
                                    <p>
                                      {acceptedSolution &&
                                      acceptedSolution?.solution?.data?.summary
                                        ?.new_forced_requirement_fulfilled
                                        ? acceptedSolution?.solution?.data?.summary?.new_forced_requirement_fulfilled.toFixed(
                                            3
                                          )
                                        : 0}{" "}
                                      {acceptedSolution &&
                                      acceptedSolution?.solution?.data?.summary
                                        ?.units
                                        ?.new_forced_requirement_fulfilled
                                        ? capitalize(
                                            weightUnit[
                                              acceptedSolution?.solution?.data
                                                ?.summary?.units
                                                ?.new_forced_requirement_fulfilled
                                            ].displayName
                                          )
                                        : "T"}
                                    </p>
                                  </li>
                                </>
                              )}
                            </ul>
                          </Col>
                          <Col span={12}>
                            <ul>
                              <li>
                                <span>Rewinder</span>
                                <p style={{ wordWrap: "break-word" }}>
                                  {
                                    jobCard.jobcard?.group?.machines[0]
                                      ?.rewinder_name
                                  }
                                </p>
                              </li>
                              <li>
                                <span>Product Specifications</span>
                                <p style={{ wordWrap: "break-word" }}>
                                  {jobCard?.jobcard?.product?.product_spec}
                                </p>
                              </li>
                              <div
                                style={{
                                  opacity: isParentReelCancelled ? 0.65 : 1,
                                }}
                              >
                                <li>
                                  <span>Fulfilled Quantity</span>
                                  <p>
                                    {acceptedSolution.solution?.data.summary
                                      .fulfilled_requirement_weight
                                      ? `${acceptedSolution.solution.data.summary.fulfilled_requirement_weight?.toFixed(
                                          3
                                        )} ${
                                          acceptedSolution.solution.data.summary
                                            .units &&
                                          acceptedSolution.solution.data.summary
                                            .units.fulfilled_requirement_weight
                                            ? capitalize(
                                                weightUnit[
                                                  acceptedSolution.solution.data
                                                    .summary.units
                                                    .fulfilled_requirement_weight
                                                ]?.displayName
                                              )
                                            : "T"
                                        }`
                                      : 0}
                                  </p>
                                </li>
                                <li>
                                  <span>Total Number of Sets</span>
                                  <p>
                                    {acceptedSolution &&
                                    acceptedSolution.solution
                                      ? acceptedSolution.solution.data.summary
                                          .total_partitions
                                      : 0}
                                  </p>
                                </li>
                              </div>
                              {isParentReelCancelled && (
                                <>
                                  <li>
                                    <span>Updated Fulfilled Quantity</span>
                                    <p>
                                      {acceptedSolution.solution?.data.summary
                                        .fulfilled_requirement_weight
                                        ? `${acceptedSolution.solution.data.summary.new_fulfilled_requirement_weight?.toFixed(
                                            3
                                          )} ${
                                            acceptedSolution.solution.data
                                              .summary.units &&
                                            acceptedSolution.solution.data
                                              .summary.units
                                              .new_fulfilled_requirement_weight
                                              ? capitalize(
                                                  weightUnit[
                                                    acceptedSolution.solution
                                                      .data.summary.units
                                                      .new_fulfilled_requirement_weight
                                                  ]?.displayName
                                                )
                                              : "T"
                                          }`
                                        : 0}
                                    </p>
                                  </li>
                                  <li>
                                    <span>Updated Total Number of Sets</span>
                                    <p>
                                      {acceptedSolution &&
                                      acceptedSolution.solution
                                        ? acceptedSolution.solution.data.summary
                                            .new_total_partitions
                                        : 0}
                                    </p>
                                  </li>
                                </>
                              )}
                              <li>
                                <span>Avg. Deckle Utilization</span>
                                <p style={{ wordWrap: "break-word" }}>
                                  {acceptedSolution.solution?.data.summary?.[
                                    "avg_utilized_deckle_" +
                                      jobCard.jobcard?.group?.machines[0]
                                        ?.machine_id
                                  ]?.toFixed(3)}{" "}
                                  {jobCard.jobcard.group.machines[0].units &&
                                  jobCard.jobcard.group.machines[0].units
                                    .deckle_size_ub
                                    ? lengthUnit[
                                        jobCard.jobcard.group.machines[0].units
                                          .deckle_size_ub
                                      ]?.displayName?.toUpperCase()
                                    : "CM"}
                                </p>
                              </li>
                            </ul>
                          </Col>
                        </Row>

                        {jobCard.jobcard.group.merged && (
                          <div className="alertmsd">
                            <h4>Merge Orders</h4>
                            <AlertContainer
                              color="blue"
                              icon={alertBlue}
                              msg="This Jobcard has merged orders"
                            />
                          </div>
                        )}
                        {jobCard.state == "rejected" && (
                          <div className="alertmsd">
                            <h4>Approver Remarks</h4>
                            <AlertContainer
                              color="red"
                              icon={alertRed}
                              msg={
                                jobCard.comments.length
                                  ? jobCard.comments
                                  : `Approver remarks does not have any data`
                              }
                            />
                          </div>
                        )}
                      </div>
                    </Panes>
                    {orderManagementSettings &&
                      (jobCard.state === "in_production" ||
                        jobCard.state === "complete" ||
                        jobCard.state === "hold") &&
                      !orderManagementSettings?.fetch_balance_quantity
                        ?.value && (
                        <Panes tab="Map Jumbo Reels" key="2">
                          <HaberForm className="mapped-col">
                            <Form name="basic" autoComplete="off">
                              <Row gutter={10} span={24}>
                                <Col span={6}>
                                  <Form.Item
                                    name="leftTrim"
                                    label="Left Edge Trim"
                                    initialValue={jobCard.jobcard.group.machines[0].left_edge_trim.toFixed(
                                      3
                                    )}
                                    className="dBlock"
                                  >
                                    <Input
                                      disabled
                                      suffix={
                                        jobCard.jobcard.group.machines[0]
                                          ?.units &&
                                        jobCard.jobcard.group.machines[0]?.units
                                          .left_edge_trim
                                          ? lengthUnit[
                                              jobCard.jobcard.group.machines[0]
                                                ?.units.left_edge_trim
                                            ]?.displayName?.toUpperCase()
                                          : "CM"
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={6}>
                                  <Form.Item
                                    name="rightTrim"
                                    label="Right Edge Trim"
                                    initialValue={jobCard.jobcard.group.machines[0].right_edge_trim.toFixed(
                                      3
                                    )}
                                    className="dBlock"
                                  >
                                    <Input
                                      disabled
                                      suffix={
                                        jobCard.jobcard.group.machines[0]
                                          ?.units &&
                                        jobCard.jobcard.group.machines[0]?.units
                                          .right_edge_trim
                                          ? lengthUnit[
                                              jobCard.jobcard.group.machines[0]
                                                ?.units.right_edge_trim
                                            ]?.displayName?.toUpperCase()
                                          : "CM"
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={6}>
                                  <Form.Item
                                    name="decklewWidth"
                                    label={
                                      jobCard.jobcard.group.grouping_params
                                        .core_id &&
                                      jobCard.jobcard.group.grouping_params
                                        .reel_od &&
                                      jobCard.jobcard.group.machines[0]
                                        .machine_type !== "cutter"
                                        ? "Deckle Width"
                                        : "Maximum Deckle Width"
                                    }
                                    initialValue={
                                      jobCard.jobcard.group.machines[0]
                                        .machine_type !== "cutter"
                                        ? (
                                            jobCard.jobcard.group.machines[0]
                                              .deckle_size_ub +
                                            (jobCard.jobcard.group.machines[0]
                                              .left_edge_trim +
                                              jobCard.jobcard.group.machines[0]
                                                .right_edge_trim) *
                                              CoversionFactorUnitsToCM[
                                                jobCard.jobcard.group
                                                  .machines[0].units
                                                  ?.right_edge_trim
                                              ] *
                                              CoversionFactorCMToUnits[
                                                jobCard.jobcard.group
                                                  .machines[0].units
                                                  ?.deckle_size_ub
                                              ]
                                          ).toFixed(3)
                                        : (
                                            jobCard.jobcard.group.machines[0]
                                              .deckle_length_ub +
                                            (jobCard.jobcard.group.machines[0]
                                              .left_edge_trim +
                                              jobCard.jobcard.group.machines[0]
                                                .right_edge_trim) *
                                              CoversionFactorUnitsToCM[
                                                jobCard.jobcard.group
                                                  .machines[0].units
                                                  ?.right_edge_trim
                                              ] *
                                              CoversionFactorCMToUnits[
                                                jobCard.jobcard.group
                                                  .machines[0].units
                                                  ?.deckle_size_ub
                                              ]
                                          ).toFixed(3)
                                    }
                                    className="dBlock"
                                  >
                                    <Input
                                      disabled
                                      suffix={
                                        jobCard.jobcard.group.machines[0]
                                          .units &&
                                        jobCard.jobcard.group.machines[0].units
                                          .deckle_size_ub
                                          ? lengthUnit[
                                              jobCard.jobcard.group.machines[0]
                                                .units.deckle_size_ub
                                            ]?.displayName?.toUpperCase()
                                          : "CM"
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                {jobCard.jobcard.group.grouping_params
                                  .core_id &&
                                jobCard.jobcard.group.grouping_params.reel_od &&
                                jobCard.jobcard.group.machines[0]
                                  .machine_type !== "cutter" ? (
                                  <Col span={6}>
                                    <Form.Item
                                      name="CoreOD/ReelOD"
                                      label="Core OD / Reel OD"
                                      initialValue={`${jobCard.jobcard.group.grouping_params.core_id} / ${jobCard.jobcard.group.grouping_params.reel_od}`}
                                      className="dBlock"
                                    >
                                      <Input
                                        disabled
                                        suffix={
                                          jobCard.jobcard.group.grouping_params
                                            .units &&
                                          jobCard.jobcard.group.grouping_params
                                            .units.reel_od
                                            ? lengthUnit[
                                                jobCard.jobcard.group
                                                  .grouping_params.units.reel_od
                                              ]?.displayName.toUpperCase()
                                            : "CM"
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : null}
                              </Row>
                            </Form>
                          </HaberForm>
                          <TableLayoutData>
                            <div
                              className="tableDataFormat "
                              style={{ marginTop: "25px" }}
                            >
                              {isMapJumboLoading ? (
                                <TableShimmer
                                  header={
                                    jobCard.jobcard.group.machines[0]
                                      .machine_type !== "cutter"
                                      ? mapJumboReelColumns.filter(
                                          (item) =>
                                            item.dataIndex !== "chop_size"
                                        )
                                      : mapJumboReelColumns.filter(
                                          (item) =>
                                            item.dataIndex !== "diaValue"
                                        )
                                  }
                                  scroll={2000}
                                />
                              ) : (
                                <Table
                                  columns={
                                    jobCard.jobcard.group.machines[0]
                                      .machine_type !== "cutter"
                                      ? mapJumboReelColumns.filter(
                                          (item) =>
                                            item.dataIndex !== "chop_size"
                                        )
                                      : mapJumboReelColumns.filter(
                                          (item) =>
                                            item.dataIndex !== "diaValue"
                                        )
                                  }
                                  dataSource={jumboReelData}
                                  onChange={onChange}
                                  scroll={{
                                    x: window.screen.width < 1500 && 1150,
                                  }}
                                  pagination={{
                                    current: currentPage,
                                    total: jumboReelData
                                      ? jumboReelData.length
                                      : 0,
                                    showTitle: false,
                                    showTotal: (total, range) =>
                                      `Showing ${range[0]}-${range[1]} of ${total} results`,
                                    pageSizeOptions: [10, 20, 50, 100],
                                    pageSize: pageSize,
                                    showSizeChanger: true,
                                  }}
                                />
                              )}
                            </div>
                          </TableLayoutData>
                        </Panes>
                      )}
                    <Panes
                      tab={
                        <span>
                          Size Fulfilment
                          {activeTab == "3" && (
                            <Button
                              key="1"
                              style={{ border: "none" }}
                              onClick={(e) => setSizeExpanded(!sizeExpanded)}
                            >
                              <Iconmoon
                                icon={
                                  sizeExpanded
                                    ? "contract_arrow"
                                    : "expand_arrow"
                                }
                                size={14}
                                color="#EA4E2C"
                              />
                            </Button>
                          )}
                        </span>
                      }
                      key="3"
                    >
                      {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                      <TableLayoutData>
                        <div
                          className="tableDataFormat  "
                          style={{ marginTop: "25px" }}
                        >
                          <Table
                            columns={sizeFulfillmentColumnsHead}
                            // dataSource={sizeFulfillmentDetailsList?.filter(
                            //   (order) => order.fulflilledWeight.split(" ")[0] > 0
                            // )}
                            dataSource={sizeFulfillmentDetailsList}
                            onChange={onChange}
                            scroll={{ x: 1200 }}
                            rowClassName={(record) => record.priority && "true"}
                            pagination={{
                              total: sizeFulfillmentDetailsList?.length,
                              showTitle: false,
                              showTotal: (total, range) =>
                                `Showing ${range[0]}-${range[1]} of ${total} results`,
                              pageSizeOptions: [10, 20, 50, 100],
                              pageSize: pageSize,
                              current: currentPage,
                              showSizeChanger: true,
                            }}
                          />
                        </div>
                      </TableLayoutData>
                    </Panes>
                    
                     <Panes
                      tab={
                        <span>
                          Order Fulfillment
                          {activeTab == "4" && (
                            <Button
                              key="1"
                              style={{ border: "none" }}
                              onClick={(e) => setSizeExpanded(!sizeExpanded)}
                            >
                              <Iconmoon
                                icon={
                                  sizeExpanded
                                    ? "contract_arrow"
                                    : "expand_arrow"
                                }
                                size={14}
                                color="#EA4E2C"
                              />
                            </Button>
                          )}
                        </span>
                      }
                      key="4"
                    >
                      <TableLayoutData>
                        <div
                          className="tableDataFormat  "
                          style={{ marginTop: "25px" }}
                        >
                          {" "}
                          {isFetchingData ? (
                            <TableShimmer header={orderFulfillmentColumnsHead} scroll={1600} />
                          ) : (
                            <Table
                              columns={orderFulfillmentColumnsHead}
                              dataSource={orderDetailsList}
                              onChange={onChange}
                              scroll={{ x: 1800 }}
                              rowClassName={(record) =>
                                record.priority && "true"
                              }
                              pagination={{
                                current: currentPage,
                                pageSize: pageSize,
                                total: orderDetailsList?.length,
                                onChange: onPaginationChange,
                                showSizeChanger: true,
                                showQuickJumper: false,
                                // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                showTotal: (total, range) =>
                                `Showing ${range[0]}-${range[1]} of ${total} results`,
                                pageSizeOptions: [10, 20, 50, 100],
                              }}
                            />
                          )}
                        </div>
                      </TableLayoutData>
                    </Panes>
                    
                    <Panes
                      tab={
                        <span>
                          Intermediate Reels
                          {activeTab == "6" && (
                            <Button
                              key="1"
                              style={{ border: "none" }}
                              onClick={(e) => setSizeExpanded(!sizeExpanded)}
                            >
                              <Iconmoon
                                icon={
                                  sizeExpanded
                                    ? "contract_arrow"
                                    : "expand_arrow"
                                }
                                size={14}
                                color="#EA4E2C"
                              />
                            </Button>
                          )}
                        </span>
                      }
                      key="6"
                      // disabled={solutionSummary?.solution1.exception}
                    >
                      {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                      <TableLayoutData>
                        <div
                          className="tableDataFormat"
                          style={{ marginTop: "25px" }}
                        >
                          <Table
                            columns={intermediateColumnsHead}
                            dataSource={intermediateData}
                            onChange={onChange}
                            scroll={{ x: 1200 }}
                            rowClassName={(record) => record.priority && "true"}
                            pagination={{
                                  total: intermediateData?.length,
                                  showTitle: false,
                                  showTotal: (total, range) =>
                                    `Showing ${range[0]}-${range[1]} of ${total} results`,
                                  pageSizeOptions: [10, 20, 50, 100],
                                  current: currentPage,
                                  pageSize: pageSize,
                                  showSizeChanger: true,
                            }}
                          />
                        </div>
                      </TableLayoutData>
                    </Panes>
                  </Tabs>
                </Col>
              </Row>
            </div>
          </DetailFields>
          {/* approve Modal */}
          <ConfirmationModal
            visible={isVisibleApproveModal}
            icon={warning}
            cancelAction={approveModalClose}
            confirmAction={approveModalConfirm}
            param={jobId}
          >
            <span>Are you sure?</span>
            <p>
              You are about to approve this job card, once approved this job
              card can’t be altered later
            </p>
          </ConfirmationModal>

          {/* <ConfirmationModal
          visible={visibleStartProduction}
          icon={warning}
          cancelAction={closeStartProductionModal}
          confirmAction={startProductionModalConfirm}
          param={jobId}
        >
          <span>Start production ?</span>
          <p>
            The job card will move to the production. Are you sure you want to
            proceed?
          </p>
        </ConfirmationModal> */}

          {/* <ConfirmationModal
          visible={visibleCancelProduction}
          icon={warning}
          cancelAction={closeCancelProductionModal}
          confirmAction={cancelProductionModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to cancel the production for this jobcard, are you
            sure you want to continue?
          </p>
        </ConfirmationModal> */}

          {/* <ConfirmationModal
          visible={visibleMarkCompletedModal}
          icon={warning}
          cancelAction={closeMarkCompletedModal}
          confirmAction={markCompletedModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to mark this job as completed, are you sure you want
            to continue?
          </p>
        </ConfirmationModal> */}

          <JobCardRejectDrawer
            visible={visibleRejectDrawer}
            onClose={closeRejectDrawer}
            onCloseGrade={closeRejectDrawer}
            jobId={jobId}
            setReFetch={setReFetch}
            setActionResponse={setActionResponse}
            showToaster={showToaster}
            jobcardCode={jobcardCode}
          />

          {viewParentReelJobCardDrawer && (
            <ParentReelJobCardDrawer
              parentReelId={selectedParentReel}
              visible={viewParentReelJobCardDrawer}
              onCloseParentReelCancel={onCloseParentReelCancel}
              onClose={closeParentReelJobCard}
              isProduced={isProduced}
              tabNo={activeTab}
              jobcardType={jobcardType}
              pageType={"deckle"}
            />
          )}

          {toaster && actionResponse.msg && (
            <AlertContainer
              color={`${actionResponse.error ? "red" : "green"} toaster`}
              icon={actionResponse.error ? alertRed : alertGreen}
              msg={capitalize(actionResponse.msg)}
            />
          )}

          <ViewDeckleOrder
            selectedOrderNo={selectedOrderNo}
            // showButton={true}
            visible={viewOrder}
            onClose={closeViewDrawer}
            onCloseGrade={closeViewDrawer}
            category={selectedOrder?.category}
          />
        </ResultWrap>
      </RightLayoutContainer>
    )
  ) 
  
  : (
    <RightLayoutContainer>
      {/* {console.log("Jobcard", jobCard)} */}
      <PageTitleComp className="marginRightAdg" style={{ borderBottom: "0px" }}>
        <PageHeader
          ghost={false}
          onBack={() => navigate("../job-cards")}
          // onBack={() => navigate(-2)} 
          title="Job Card Details"
        ></PageHeader>
      </PageTitleComp>
      <ResultWrap>
        <DetailFields
          className="jobCardView"
          style={{ justifyContent: "flex-start" }}
        >
          <PageTitleComp style={{ borderBottom: "0" }}>
            <PageHeader
              ghost={false}
              // title={`Job Card ${jobCard.id}`}
              className="jobCardList-Grid"
            ></PageHeader>

            <div
              className={`jobCardList ${"fullWidth"}`}
              style={{
                alignSelf: "center",
                display: "flex",
                marginTop:
                  isParentReelCancelled && activeTab >= 2 ? "20px" : "34px",
                // alignContent:'top'
              }}
            >
              {/* <JobCardColorStatus>
                <div className="statusVal" dataval={jobCard.state}>
                  {jobcardState(jobCard.state)}
                </div>
              </JobCardColorStatus> */}
            </div>
            {isParentReelCancelled && activeTab >= 2 && (
              <Col span={9} style={{ display: "absolute" }}>
                <div
                  className="cancelledSetMessage"
                  style={{
                    display: "flex",
                    justifyContent: "center", // Center content horizontally
                    alignItems: "center", // Center content vertically
                    marginTop: "25px",
                    borderRadius: "4px",
                    backgroundColor: "#f4f0ec",
                    padding: "4px 6px",
                    opacity: 0.95,
                  }}
                >
                  {/* <div className="centerAlignMeVertically" style={{ padding: "2px 6px 0px 3px" }}>
    <Iconmoon icon="warning_new" size={20} style={{ color: "#808080" }} />
  </div>
  <span style={{ fontSize: "14px", color: "#555555" }}>
    A few sets were cancelled in this job card. Hence, fulfilled
    quantity might not be accurate for the cancelled sets.
  </span> */}
                </div>
              </Col>
            )}
          </PageTitleComp>

          <div className="MatchResult JobResulted">
            <Row span={24}>
              <Col
                span={15}
                className="pipeBlock"
                style={{
                  paddingRight: "20px",
                  transform:
                    isParentReelCancelled && activeTab >= 2
                      ? "translateY(-14px)"
                      : "",
                }}
              >
                <div
                  style={{
                    paddingTop: "50px",
                    paddingBottom: "50px",
                  }}
                >
                  <CardShimmerStyle>
                    <div
                      style={{
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                        opacity: "70%",
                        width: "341.62px",
                        marginTop: "60px",
                      }}
                    >
                      <Skeleton.Image
                        active={true}
                        style={{
                          width: "105px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      />
                    </div>
                  </CardShimmerStyle>
                  {/* <div 
            style={{
                fontFamily: "var(--sf-pro-display-m)",
                fontWeight: "500",
                fontSize: "14px",
                height: "16px",
                color: "#A19F9D",
                paddingTop: "20px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "150px",
                textAlign: "center",
           }}
           >{heading}
            </div> */}
                  <div
                    style={{
                      paddingTop: "30px",
                      fontFamily: "var(--sf-pro-display-m)",
                      fontWeight: "400",
                      fontSize: "12px",
                      height: "20px",
                      color: "#A19F9D",
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                      width: "311px",
                      textAlign: "center",
                    }}
                  >
                    {"Fetching jobcard details"}
                  </div>
                </div>
              </Col>
              <Col span={9} className="colLayoutBlock leftPostTab">
                <Tabs
                  defaultActiveKey="1"
                  activeKey={activeTab}
                  onChange={tabChange}
                  className="topPostTab innerPostTab"
                >
                  <Panes tab="Summary" key="1">
                    <div className="lossValue">
                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>

                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>

                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "60px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "60px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>
                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px", backgroundColor: "white" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "70%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "20px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px", backgroundColor: "white" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "70%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "20px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Panes>
                  <Panes tab="Size Fulfilment" key="2">
                    {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                    <TableLayoutData>
                      <div
                        className="tableDataFormat  "
                        style={{ marginTop: "25px" }}
                      >
                        <TableShimmer
                          header={sizeFulfillmentColumnsHead}
                          scroll={1300}
                        />
                      </div>
                    </TableLayoutData>
                  </Panes>
                  
                  <Panes tab="Order Fulfillment" key="3">
                    <TableLayoutData>
                      <div
                        className="tableDataFormat  "
                        style={{ marginTop: "25px" }}
                      >
                        <TableShimmer header={orderFulfillmentColumnsHead} scroll={1600} />
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes
                    tab="Intermediate Reels"
                    key="5"
                    // disabled={solutionSummary?.solution1.exception}
                  >
                    {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                    <TableLayoutData>
                      <div
                        className="tableDataFormat"
                        style={{ marginTop: "25px" }}
                      >
                        <TableShimmer
                          header={intermediateColumnsHead}
                          scroll={1300}
                        />
                      </div>
                    </TableLayoutData>
                  </Panes>
                </Tabs>
              </Col>
            </Row>
          </div>
        </DetailFields>
        {/* approve Modal */}
        <ConfirmationModal
          visible={isVisibleApproveModal}
          icon={warning}
          cancelAction={approveModalClose}
          confirmAction={approveModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to approve this job card, once approved this job card
            can’t be altered later
          </p>
        </ConfirmationModal>

        {/* <ConfirmationModal
          visible={visibleStartProduction}
          icon={warning}
          cancelAction={closeStartProductionModal}
          confirmAction={startProductionModalConfirm}
          param={jobId}
        >
          <span>Start production ?</span>
          <p>
            The job card will move to the production. Are you sure you want to
            proceed?
          </p>
        </ConfirmationModal> */}

        {/* <ConfirmationModal
          visible={visibleCancelProduction}
          icon={warning}
          cancelAction={closeCancelProductionModal}
          confirmAction={cancelProductionModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to cancel the production for this jobcard, are you
            sure you want to continue?
          </p>
        </ConfirmationModal> */}

        {/* <ConfirmationModal
          visible={visibleMarkCompletedModal}
          icon={warning}
          cancelAction={closeMarkCompletedModal}
          confirmAction={markCompletedModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to mark this job as completed, are you sure you want
            to continue?
          </p>
        </ConfirmationModal> */}

        <JobCardRejectDrawer
          visible={visibleRejectDrawer}
          onClose={closeRejectDrawer}
          onCloseGrade={closeRejectDrawer}
          jobId={jobId}
          setReFetch={setReFetch}
          setActionResponse={setActionResponse}
          showToaster={showToaster}
          jobcardCode={jobcardCode}
        />

        {toaster && actionResponse.msg && (
          <AlertContainer
            color={`${actionResponse.error ? "red" : "green"} toaster`}
            icon={actionResponse.error ? alertRed : alertGreen}
            msg={capitalize(actionResponse.msg)}
          />
        )}

        <ViewDeckleOrder
          selectedOrderNo={selectedOrderNo}
          // showButton={true}
          visible={viewOrder}
          onClose={closeViewDrawer}
          onCloseGrade={closeViewDrawer}
          category={selectedOrder?.category}
        />
      </ResultWrap>
    </RightLayoutContainer>
  );
};
export default JobCardDetailData;
